"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3827],{

/***/ 28702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cp": function() { return /* binding */ changePassword; },
/* harmony export */   "Ds": function() { return /* binding */ signupWithCompanyInfo; },
/* harmony export */   "IT": function() { return /* binding */ registerWithLogin; },
/* harmony export */   "IU": function() { return /* binding */ signup; },
/* harmony export */   "KJ": function() { return /* binding */ signupCompanyUser; },
/* harmony export */   "Uv": function() { return /* binding */ signupV2; },
/* harmony export */   "Vq": function() { return /* binding */ sendGetIds; },
/* harmony export */   "_J": function() { return /* binding */ sendCert; },
/* harmony export */   "c1": function() { return /* binding */ sendFindPasswordMail; },
/* harmony export */   "ot": function() { return /* binding */ subscribeStibee; },
/* harmony export */   "vB": function() { return /* binding */ confirmCert; },
/* harmony export */   "x4": function() { return /* binding */ login; },
/* harmony export */   "y0": function() { return /* binding */ signupCompanyUserV2; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53249);




var login = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(userId, password, userType) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/login", (_tmp.userId = userId, _tmp.password = password, _tmp.userType = userType, _tmp))
                    ];
                case 1:
                    response = _state.sent();
                    window.localStorage.setItem("accessToken", response.data.accessToken);
                    window.localStorage.setItem("refreshToken", response.data.refreshToken);
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function login(userId, password, userType) {
        return _ref.apply(this, arguments);
    };
}();
var registerWithLogin = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(userId, password, key) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/loginWithRegister", (_tmp.userId = userId, _tmp.password = password, _tmp.key = key, _tmp))
                    ];
                case 1:
                    response = _state.sent();
                    window.localStorage.setItem("accessToken", response.data.accessToken);
                    window.localStorage.setItem("refreshToken", response.data.refreshToken);
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function registerWithLogin(userId, password, key) {
        return _ref.apply(this, arguments);
    };
}();
var subscribeStibee = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/utils/stibee/subscribe", data)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function subscribeStibee(data) {
        return _ref.apply(this, arguments);
    };
}();
var sendFindPasswordMail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(email) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/email/password", (_tmp.email = email, _tmp))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function sendFindPasswordMail(email) {
        return _ref.apply(this, arguments);
    };
}();
var signup = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(userData) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/join", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_tmp, userData))
                    ];
                case 1:
                    response = _state.sent();
                    window.localStorage.setItem("accessToken", response.data.accessToken);
                    window.localStorage.setItem("refreshToken", response.data.refreshToken);
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function signup(userData) {
        return _ref.apply(this, arguments);
    };
}();
var signupCompanyUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(userData) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/join/company-user", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_tmp, userData))
                    ];
                case 1:
                    response = _state.sent();
                    window.localStorage.setItem("accessToken", response.data.accessToken);
                    window.localStorage.setItem("refreshToken", response.data.refreshToken);
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function signupCompanyUser(userData) {
        return _ref.apply(this, arguments);
    };
}();
var signupCompanyUserV2 = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(userData) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/join/company-user/v2", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_tmp, userData))
                    ];
                case 1:
                    response = _state.sent();
                    window.localStorage.setItem("accessToken", response.data.accessToken);
                    window.localStorage.setItem("refreshToken", response.data.refreshToken);
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function signupCompanyUserV2(userData) {
        return _ref.apply(this, arguments);
    };
}();
var signupV2 = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(userData) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/join/v2", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_tmp, userData))
                    ];
                case 1:
                    response = _state.sent();
                    window.localStorage.setItem("accessToken", response.data.accessToken);
                    window.localStorage.setItem("refreshToken", response.data.refreshToken);
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function signupV2(userData) {
        return _ref.apply(this, arguments);
    };
}();
var signupWithCompanyInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(userData) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/join", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_tmp, userData))
                    ];
                case 1:
                    response = _state.sent();
                    window.localStorage.setItem("accessToken", response.data.accessToken);
                    window.localStorage.setItem("refreshToken", response.data.refreshToken);
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function signupWithCompanyInfo(userData) {
        return _ref.apply(this, arguments);
    };
}();
var sendCert = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(authData, type) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/".concat(type), (_tmp.authData = authData, _tmp))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function sendCert(authData, type) {
        return _ref.apply(this, arguments);
    };
}();
var sendGetIds = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(certId, type) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.get */ .sl.get("/auth/ids?certId=".concat(certId, "&type=").concat(type))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function sendGetIds(certId, type) {
        return _ref.apply(this, arguments);
    };
}();
var confirmCert = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id, authNumber) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/cert", (_tmp.id = id, _tmp.authNumber = authNumber, _tmp))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function confirmCert(id, authNumber) {
        return _ref.apply(this, arguments);
    };
}();
var changePassword = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id, authNumber, password) {
        var response, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .apiServiceV2.post */ .sl.post("/auth/password/change", (_tmp.id = id, _tmp.authNumber = authNumber, _tmp.password = password, _tmp))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function changePassword(id, authNumber, password) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 76445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var WebpImage = function(props) {
    var src = props.src;
    var isSvg = src.endsWith(".svg");
    var webpSrc = src.replace("/onepoint/", "/webp-onepoint/").replace(/\.(png|jpg|jpeg)$/, ".webp");
    var loading = props.loading, alt = props.alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, [
        "loading",
        "alt"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
        style: {
            display: "flex",
            flexShrink: 0
        },
        children: [
            !isSvg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                srcSet: webpSrc,
                type: "image/webp"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, rest), {
                loading: loading || "lazy",
                alt: alt || src
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WebpImage);


/***/ }),

/***/ 17805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$K": function() { return /* binding */ ExpertProcessCardList; },
/* harmony export */   "$N": function() { return /* binding */ SectionSmallSubTitle; },
/* harmony export */   "AF": function() { return /* binding */ MainContentsContainer; },
/* harmony export */   "Ak": function() { return /* binding */ ReviewCard; },
/* harmony export */   "Bf": function() { return /* binding */ FAQAnswerList; },
/* harmony export */   "Bi": function() { return /* binding */ ExpertMainCtaButton; },
/* harmony export */   "DA": function() { return /* binding */ ExpertCtaContentsInnerMobile; },
/* harmony export */   "DO": function() { return /* binding */ MainCtaContentsInner; },
/* harmony export */   "Es": function() { return /* binding */ BpCard; },
/* harmony export */   "F7": function() { return /* binding */ ExpertReviewCard; },
/* harmony export */   "G1": function() { return /* binding */ CustomAccordion; },
/* harmony export */   "IH": function() { return /* binding */ HowtoSectionSmallTitle; },
/* harmony export */   "JU": function() { return /* binding */ PentagonTitle2; },
/* harmony export */   "Jy": function() { return /* binding */ AnswerListUl; },
/* harmony export */   "Ks": function() { return /* binding */ SubscribeInput; },
/* harmony export */   "L4": function() { return /* binding */ InsightCard; },
/* harmony export */   "NZ": function() { return /* binding */ SectionTitle; },
/* harmony export */   "OX": function() { return /* binding */ ExpertCtaContentsInner; },
/* harmony export */   "O_": function() { return /* binding */ WhyCardList; },
/* harmony export */   "P2": function() { return /* binding */ SectionSmallSubTitle2; },
/* harmony export */   "Qf": function() { return /* binding */ FAQAnswerDiv; },
/* harmony export */   "T8": function() { return /* binding */ MainCtaButton; },
/* harmony export */   "Tb": function() { return /* binding */ ResponsibilityData; },
/* harmony export */   "Th": function() { return /* binding */ SubscribeButton; },
/* harmony export */   "VD": function() { return /* binding */ BigInsightCard; },
/* harmony export */   "VF": function() { return /* binding */ BpList; },
/* harmony export */   "VH": function() { return /* binding */ CListPagination; },
/* harmony export */   "Vm": function() { return /* binding */ SectionSubTitle; },
/* harmony export */   "WS": function() { return /* binding */ ProcessCard; },
/* harmony export */   "X5": function() { return /* binding */ ExpertWhyOnpointData; },
/* harmony export */   "XX": function() { return /* binding */ MainCtaContentsContainer; },
/* harmony export */   "Xf": function() { return /* binding */ WhyOnePointDiv; },
/* harmony export */   "YT": function() { return /* binding */ RollingTextSpan; },
/* harmony export */   "ZK": function() { return /* binding */ ExpertProcessCard; },
/* harmony export */   "_B": function() { return /* binding */ ExpertMainCtaButtonMobile; },
/* harmony export */   "_N": function() { return /* binding */ WhyOnePointBox; },
/* harmony export */   "_R": function() { return /* binding */ ReviewData; },
/* harmony export */   "aw": function() { return /* binding */ InsightList; },
/* harmony export */   "b_": function() { return /* binding */ ReviewContainer; },
/* harmony export */   "ci": function() { return /* binding */ profileDataArray; },
/* harmony export */   "cw": function() { return /* binding */ HowToVerrifyBigTitle; },
/* harmony export */   "dO": function() { return /* binding */ HowToVerifyStepTitle; },
/* harmony export */   "dV": function() { return /* binding */ ResponsibilityCard; },
/* harmony export */   "dc": function() { return /* binding */ PentagonTitle; },
/* harmony export */   "ex": function() { return /* binding */ ExpertReviewData; },
/* harmony export */   "fN": function() { return /* binding */ SectionTitleLeftDirect; },
/* harmony export */   "gi": function() { return /* binding */ ProcessCardList; },
/* harmony export */   "hA": function() { return /* binding */ SectionSubTitleMobile; },
/* harmony export */   "ip": function() { return /* binding */ ExpertProcessCardListMobile; },
/* harmony export */   "ix": function() { return /* binding */ ContentsContainerMobile; },
/* harmony export */   "jW": function() { return /* binding */ TrustData; },
/* harmony export */   "jy": function() { return /* binding */ CIListContainer; },
/* harmony export */   "kj": function() { return /* binding */ BlogCtaButton; },
/* harmony export */   "nJ": function() { return /* binding */ WhyCard; },
/* harmony export */   "pM": function() { return /* binding */ SectionRight; },
/* harmony export */   "px": function() { return /* binding */ ExpertTrustCard; },
/* harmony export */   "rI": function() { return /* binding */ SectionTitleLeft; },
/* harmony export */   "rm": function() { return /* binding */ ExpertCtaContentsContainer; },
/* harmony export */   "tx": function() { return /* binding */ SectionSmallTitle; },
/* harmony export */   "vA": function() { return /* binding */ ExpertMainContentsContainerMobile; },
/* harmony export */   "vp": function() { return /* binding */ FAQButton; },
/* harmony export */   "wt": function() { return /* binding */ FAQAnswerDiv2; },
/* harmony export */   "xR": function() { return /* binding */ SwiperSectionContents; },
/* harmony export */   "xg": function() { return /* binding */ PentagonSubTitle; },
/* harmony export */   "y3": function() { return /* binding */ ContentsContainer; },
/* harmony export */   "yI": function() { return /* binding */ FAQAnswerTitle; },
/* harmony export */   "yb": function() { return /* binding */ SectionTitleMobile; }
/* harmony export */ });
/* unused harmony exports CtaImageBox, MainCtaButtonOutlined, WhyCardBox, ExpertProcessCardBox, ProcessCardBox, ConsultantCardListBox, ConsultantCard, SectionTitlePrimary, SectionLargeTitle, ConsultantUserList, CustomA */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52029);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54225);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76992);
/* harmony import */ var _src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76445);
/* harmony import */ var _src_ruix__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9869);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--desc-gray);\n	font-size: 20px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 150%; /* 24px */\n	letter-spacing: -0.64px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--desc-gray);\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 150%; /* 24px */\n	letter-spacing: -0.64px;\n\n	@media screen and (max-width: 1023px) {\n		font-size: 14px;\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: absolute;\n	padding: 8px;\n	border-radius: 4px;\n	background: #f6f7f8;\n\n	box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.04);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 12px 24px;\n	justify-content: center;\n	align-items: center;\n	gap: 10px;\n	border-radius: 12px;\n	color: #fff;\n	text-align: center;\n	font-size: 24px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 130%; /* 31.2px */\n	letter-spacing: -0.96px;\n	width: 280px;\n	box-shadow: 0px 6px 20px 0px rgba(56, 124, 246, 0.2);\n	transition: transform 0.2s ease, box-shadow 0.2s ease !important;\n\n	&:hover {\n		transform: translateY(-2px);\n		box-shadow: 0px 10px 28px 0px rgba(56, 124, 246, 0.3) !important;\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 12px 24px;\n	justify-content: center;\n	align-items: center;\n	gap: 10px;\n	border-radius: 4px;\n	color: var(--primary);\n	text-align: center;\n	font-size: 24px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 130%; /* 31.2px */\n	letter-spacing: -0.96px;\n	background-color: white;\n	border: 1px solid var(--primary);\n	width: 280px;\n\n	@media screen and (max-width: 1023px) {\n		display: flex;\n		padding: 12px 24px;\n		justify-content: center;\n		align-items: center;\n		gap: 10px;\n		border-radius: 4px;\n		text-align: center;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 31.2px */\n		letter-spacing: -0.96px;\n		width: 200px;\n	}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 12px 24px;\n	justify-content: center;\n	align-items: center;\n	gap: 10px;\n	border-radius: 4px;\n	border-color: var(--card-bg);\n	color: var(--card-bg);\n	text-align: center;\n	font-size: 24px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 130%; /* 31.2px */\n	letter-spacing: -0.96px;\n	background-color: white;\n\n	&:hover {\n		background-color: var(--bg-white);\n		border-color: black;\n	}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 12px 24px;\n	justify-content: center;\n	align-items: center;\n	gap: 10px;\n	border-radius: 4px;\n	border-color: var(--card-bg);\n	color: var(--card-bg);\n	text-align: center;\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 130%; /* 31.2px */\n	letter-spacing: -0.96px;\n	background-color: white;\n\n	&:hover {\n		background-color: var(--bg-white);\n		border-color: black;\n	}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 12px 20px;\n	justify-content: center;\n	align-items: center;\n	gap: 10px;\n	min-width: fit-content;\n	border-radius: 10px;\n	background-color: var(--card-bg);\n	box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.12);\n	transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease !important;\n\n	&:hover {\n		background-color: var(--bg);\n		transform: translateY(-2px);\n		box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.2) !important;\n	}\n\n	color: white;\n	text-align: center;\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 130%; /* 20.8px */\n	letter-spacing: -0.48px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	gap: 0px;\n\n	.cta-title-box {\n		span {\n			color: var(--card-bg);\n			text-align: center;\n			font-size: 48px;\n			font-style: normal;\n			font-weight: 800;\n			line-height: 116%; /* 55.68px */\n			letter-spacing: -1.92px;\n		}\n		.blue {\n			color: var(--primary);\n		}\n	}\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		transform: translateY(16px);\n		opacity: 0;\n	}\n	to {\n		transform: translateY(0);\n		opacity: 1;\n	}\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: inline-block;\n	vertical-align: bottom;\n	position: relative;\n	top: 1px;\n	margin: 0 1px 0 6px;\n	animation: ",
        " 0.5s ease forwards;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	gap: 20px;\n\n	.cta-label {\n		color: white;\n		text-align: center;\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 800;\n		line-height: 116%; /* 23.2px */\n		letter-spacing: -0.8px;\n	}\n\n	.cta-title-box {\n		span {\n			color: white;\n			text-align: center;\n			font-size: 48px;\n			font-style: normal;\n			font-weight: 800;\n			line-height: 116%; /* 55.68px */\n			letter-spacing: -1.92px;\n		}\n		.blue {\n			color: var(--primary);\n		}\n	}\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	gap: 20px;\n\n	.cta-title-box {\n		span {\n			color: white;\n			text-align: center;\n			font-size: 36px;\n			font-style: normal;\n			font-weight: 800;\n			line-height: 116%; /* 55.68px */\n			letter-spacing: -1.92px;\n		}\n		.blue {\n			color: var(--primary);\n		}\n	}\n\n	.cta-label {\n		color: white;\n		text-align: center;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 800;\n		line-height: 116%; /* 18.56px */\n		letter-spacing: -0.64px;\n	}\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding-top: 120px;\n	padding-bottom: 0px;\n	width: 100%;\n	position: relative;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding-top: 120px;\n	padding-bottom: 120px;\n	width: 100%;\n	position: relative;\n	background-color: var(--card-bg);\n\n	@media screen and (max-width: 1024px) {\n		padding-top: 72px;\n		padding-bottom: 72px;\n	}\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex: 1;\n	padding: 32px 20px;\n	width: 488px;\n	align-items: flex-start;\n	gap: 16px;\n	border-radius: 16px;\n	border: 1px solid rgba(0, 0, 0, 0.06);\n	background: #fff;\n	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);\n	transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n	&:hover {\n		transform: translateY(-4px);\n		box-shadow: 0px 12px 32px 0px rgba(0, 0, 0, 0.12);\n	}\n\n	.title {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 24px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 31.2px */\n		letter-spacing: -0.72px;\n	}\n\n	.subTitle {\n		color: var(--desc-gray);\n		font-family: Pretendard;\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n	}\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 32px 20px;\n	flex-direction: column;\n	align-items: flex-start;\n	flex: 1 0 0;\n	border-radius: 4px;\n	width: 232px;\n\n	@media screen and (max-width: 1023px) {\n		width: 100%;\n		align-items: center;\n		justify-content: center;\n	}\n\n	.title {\n		color: var(--card-bg);\n		font-size: 24px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 31.2px */\n		letter-spacing: -0.72px;\n	}\n\n	.subTitle {\n		color: var(--desc-gray);\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n	}\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 32px 20px;\n	flex-direction: column;\n	align-items: flex-start;\n	flex: 1 0 0;\n	border-radius: 16px;\n	border: 1px solid rgba(0, 0, 0, 0.06);\n	width: 232px;\n	background: #fff;\n	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);\n	transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n	&:hover {\n		transform: translateY(-4px);\n		box-shadow: 0px 12px 32px 0px rgba(0, 0, 0, 0.12);\n	}\n\n	.title {\n		color: var(--card-bg);\n		font-size: 24px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 31.2px */\n		letter-spacing: -0.72px;\n	}\n\n	.subTitle {\n		color: var(--desc-gray);\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n	}\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 200px;\n	flex: 0;\n	flex-shrink: 0;\n	max-width: 500px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 32px 20px;\n	flex-direction: column;\n	align-items: flex-start;\n	gap: 16px;\n	flex: 1 0 0;\n	border-radius: 16px;\n	border: 1px solid rgba(0, 0, 0, 0.06);\n	background: #fff;\n	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.04);\n	transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n	&:hover {\n		transform: translateY(-4px);\n		box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);\n	}\n\n	.title {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 24px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 31.2px */\n		letter-spacing: -0.72px;\n		height: 60px;\n		width: 100%;\n	}\n\n	.desc {\n		color: var(--desc-gray);\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 24px */\n		letter-spacing: -0.64px;\n		height: 120px;\n	}\n\n	.img {\n		height: 30px;\n		flex-shrink: 0;\n		margin-top: 10px;\n		margin-bottom: 10px;\n	}\n\n	.name {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 800;\n		line-height: 130%; /* 20.8px */\n		letter-spacing: -0.48px;\n	}\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 32px 20px;\n	flex-direction: column;\n	align-items: flex-start;\n	gap: 16px;\n	flex: 1 0 0;\n	border-radius: 16px;\n	border: 1px solid rgba(0, 0, 0, 0.06);\n	background: #fff;\n	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);\n	transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n	&:hover {\n		transform: translateY(-4px);\n		box-shadow: 0px 12px 32px 0px rgba(0, 0, 0, 0.12);\n	}\n\n	.title {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 24px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 31.2px */\n		letter-spacing: -0.72px;\n		height: 60px;\n		width: 100%;\n	}\n\n	.desc {\n		color: var(--desc-gray);\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 24px */\n		letter-spacing: -0.64px;\n		height: 140px;\n	}\n\n	.name {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 800;\n		line-height: 130%; /* 20.8px */\n		letter-spacing: -0.48px;\n		gap: 4px;\n\n		.name-gray {\n			color: var(--desc-gray);\n		}\n	}\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 30px 2px 13px 2px;\n	flex-direction: column;\n	justify-content: flex-end;\n	align-items: center;\n	gap: 12px;\n	border-radius: 16px;\n	border: 1px solid rgba(0, 0, 0, 0.06);\n	background: #fff;\n	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);\n	transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n	&:hover {\n		transform: translateY(-4px);\n		box-shadow: 0px 12px 32px 0px rgba(0, 0, 0, 0.12);\n	}\n\n	.profile-img {\n		width: 88px;\n		height: 88px;\n		border-radius: 50%;\n		object-fit: cover;\n	}\n\n	.name {\n		color: var(--card-bg);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 24px;\n		font-style: normal;\n		font-weight: 800;\n		line-height: 120%; /* 28.8px */\n		letter-spacing: -0.96px;\n	}\n\n	.desc {\n		color: var(--desc-gray);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 24px */\n		letter-spacing: -0.64px;\n	}\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	gap: 160px;\n\n	.ci-list .swiper-wrapper {\n		transition-timing-function: linear !important;\n		/* 추가: 모바일에서 드래그 시 끊김 방지 */\n		-webkit-transition-timing-function: linear !important;\n	}\n\n	.hidden {\n		opacity: 0;\n		pointer-events: none;\n	}\n\n	.floating {\n		display: flex;\n		flex-direction: column;\n		justify-content: center;\n		align-items: center;\n		gap: 10px;\n		position: fixed;\n		bottom: 50px;\n		left: 50%;\n		transform: translateX(-50%);\n		z-index: 1000;\n	}\n\n	.floating-btn-apply,\n	.floating-btn-consult {\n		display: flex;\n		flex-direction: row;\n		justify-content: center;\n		align-items: center;\n		font-size: 18px;\n		font-weight: bold;\n		padding: 10px 10px;\n		padding-right: 5px;\n		border-radius: 30px;\n		width: 240px;\n		cursor: pointer;\n		height: 60px;\n		box-shadow: 0 19px 38px rgba(0, 0, 0, 0.5);\n		transition: 0.3s ease;\n\n		&:hover {\n			transform: translateY(-4px);\n			box-shadow: 0 24px 48px rgba(0, 0, 0, 0.6);\n		}\n	}\n\n	.floating-btn-apply {\n		background-color: var(--primary);\n		color: white;\n	}\n\n	.floating-btn-consult {\n		background-color: white;\n		color: var(--primary);\n	}\n\n	@media screen and (max-width: 768px) {\n		.floating-btn-apply,\n		.floating-btn-consult {\n			width: 160px;\n			height: 50px;\n			border-radius: 50px;\n			font-size: 16px;\n		}\n	}\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	gap: 80px;\n\n	.hidden {\n		opacity: 0;\n		pointer-events: none;\n	}\n\n	#floating-btn {\n		position: fixed;\n		bottom: 50px;\n		left: 50%;\n		transform: translateX(-50%);\n		z-index: 1000;\n		display: flex;\n		flex-direction: row;\n		justify-content: center;\n		align-items: center;\n		background-color: var(--primary);\n		font-size: 18px;\n		font-weight: bold;\n		color: white;\n		padding: 10px 10px;\n		padding-right: 5px;\n		border-radius: 30px;\n		width: 230px;\n		cursor: pointer;\n		height: 60px;\n		box-shadow: 0 19px 38px rgba(0, 0, 0, 0.5);\n		transition: 0.3s ease;\n	}\n\n	@media screen and (max-width: 768px) {\n		#floating-btn {\n			width: 160px;\n			height: 50px;\n			border-radius: 50px;\n			font-size: 16px;\n		}\n	}\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	max-width: 1024px;\n	padding: 0 20px;\n	position: relative;\n	margin: 0 auto;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	max-width: 1024px;\n	padding: 0 8px;\n	position: relative;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	text-align: center;\n	font-size: 40px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 48px */\n	letter-spacing: -1.6px;\n\n	@media screen and (max-width: 1023px) {\n		font-size: 24px;\n	}\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--primary);\n	text-align: left;\n	font-size: 32px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 48px */\n	letter-spacing: -1.6px;\n\n	@media screen and (max-width: 1023px) {\n		font-size: 24px;\n	}\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	text-align: center;\n	font-size: 24px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 48px */\n	letter-spacing: -1.6px;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--primary);\n	font-size: 40px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 48px */\n	letter-spacing: -1.6px;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	font-size: 40px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 48px */\n	letter-spacing: -1.6px;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	font-size: 28px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 48px */\n	letter-spacing: -1.6px;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--desc-gray);\n	text-align: center;\n	font-size: 20px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 150%; /* 30px */\n	letter-spacing: -0.8px;\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--desc-gray);\n	text-align: center;\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 150%; /* 30px */\n	letter-spacing: -0.8px;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	text-align: center;\n	font-size: 32px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 38.4px */\n	letter-spacing: -1.28px;\n\n	> span {\n		color: var(--primary);\n	}\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	text-align: center;\n	font-size: 24px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 120%; /* 28.8px */\n	letter-spacing: -0.72px;\n\n	> span {\n		color: var(--primary);\n	}\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--primary);\n	text-align: left;\n	font-size: 20px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 150%; /* 30px */\n	letter-spacing: -0.8px;\n	max-width: 816px;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	text-align: left;\n	width: 100%;\n	font-size: 20px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 150%; /* 30px */\n	letter-spacing: -0.8px;\n	max-width: 816px;\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding: 56px 80px;\n	background-color: var(--bg-white);\n	width: 100%;\n\n	@media screen and (max-width: 768px) {\n		padding: 20px 10px;\n	}\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	gap: 8px;\n	.label {\n		color: var(--primary);\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 26px */\n		letter-spacing: -0.6px;\n	}\n\n	.title {\n		color: var(--desc-gray);\n		font-size: 32px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 41.6px */\n		letter-spacing: -0.96px;\n\n		.bold {\n			color: var(--card-bg);\n		}\n	}\n\n	.description {\n		color: var(--desc-gray);\n		font-size: 24px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 36px */\n		letter-spacing: -0.96px;\n	}\n\n	@media screen and (max-width: 1023px) {\n		.title {\n			font-size: 24px;\n		}\n\n		.description {\n			font-size: 20px;\n		}\n	}\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	.swiper-pagination {\n		position: relative;\n		width: 100px !important;\n	}\n\n	.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,\n	.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {\n		background-color: var(--card-bg);\n	}\n	.profile-box {\n		width: 100%;\n		max-width: 1200px;\n		overflow: hidden;\n\n		.swiper {\n			padding-bottom: 50px;\n		}\n\n		.swiper-slide {\n			display: flex;\n			justify-content: center;\n			align-items: center;\n		}\n\n		.swiper-button-group {\n			position: absolute;\n			top: 50%;\n			transform: translateY(-50%);\n			width: 40px;\n			height: 40px;\n			padding-bottom: 100px;\n			cursor: pointer;\n\n			svg {\n				color: white;\n				font-size: 40px;\n			}\n		}\n\n		@media (max-width: 1200px) {\n			.swiper-button-group {\n				display: none;\n			}\n\n			.review-box {\n				padding-left: 0px;\n				padding-right: 0px;\n			}\n\n			div.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {\n				span.swiper-pagination-bullet-active {\n					background: white;\n				}\n				span.swiper-pagination-bullet {\n					width: 20px;\n				}\n			}\n		}\n\n		.swiper-button-prev-unique {\n			left: 0px;\n		}\n\n		.swiper-button-next-unique {\n			right: 0px;\n			z-index: 100;\n		}\n\n		.swiper-button-prev {\n			color: white;\n		}\n\n		.swiper-button-next {\n			color: white;\n		}\n\n		.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {\n			span.swiper-pagination-bullet-active {\n				background: white;\n			}\n			span.swiper-pagination-bullet {\n				width: 30px;\n				border-radius: 20px;\n			}\n		}\n	}\n\n	.profile-box {\n		.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {\n			span.swiper-pagination-bullet {\n				background: black;\n			}\n		}\n	}\n\n	@media screen and (max-width: 500px) {\n		.profile-box {\n			padding-bottom: 100px;\n			padding-left: 30px;\n			padding-right: 30px;\n		}\n	}\n\n	.profile-item {\n		display: flex;\n		flex-direction: column;\n		/* width: 100%; */\n		border-radius: 16px;\n		position: relative;\n		/* background-color: white; */\n		border: 1px solid rgba(0, 0, 0, 0.06);\n		box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);\n		transition: transform 0.25s ease, box-shadow 0.25s ease;\n\n		&:hover {\n			transform: translateY(-6px);\n			box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.13);\n		}\n\n		.top-box {\n			display: flex;\n			width: 100%;\n			flex-direction: column;\n			justify-content: start;\n			align-items: start;\n			position: relative;\n			border-top-right-radius: 40px;\n			border-top-left-radius: 40px;\n			z-index: 1;\n			padding: 0px 25px 0px 25px;\n			padding-top: 16px;\n\n			.name {\n				color: var(--card-bg);\n				font-family: Pretendard;\n				font-size: 24px;\n				font-style: normal;\n				font-weight: 800;\n				line-height: 120%; /* 28.8px */\n				letter-spacing: -0.96px;\n				padding-top: 16px;\n			}\n\n			.job {\n				color: var(--card-bg);\n				font-family: Pretendard;\n				font-size: 20px;\n				font-style: normal;\n				font-weight: 500;\n				line-height: 150%; /* 30px */\n				letter-spacing: -0.6px;\n			}\n\n			.profile-img {\n				width: 88px;\n				height: 88px;\n				border-radius: 100%;\n				overflow: hidden;\n				object-fit: cover;\n			}\n		}\n\n		.bottom-box {\n			display: flex;\n			flex-direction: column;\n			justify-content: start;\n			align-items: start;\n			position: relative;\n			flex-wrap: wrap;\n			background-color: white;\n			border-bottom-right-radius: 40px;\n			border-bottom-left-radius: 40px;\n			padding: 0px 0px 30px 25px;\n			gap: 12px;\n\n			.introduction {\n				color: var(--desc-gray);\n				font-size: 16px;\n				font-style: normal;\n				font-weight: 500;\n				line-height: 150%; /* 24px */\n				letter-spacing: -0.64px;\n			}\n\n			.tag-box,\n			.skill-box {\n				display: flex;\n				flex-direction: row;\n				justify-content: start;\n				align-items: start;\n				gap: 0px;\n				min-height: 40px;\n				flex-wrap: wrap;\n\n				.skill,\n				.tag {\n					display: flex;\n					padding: 0px 0px;\n					min-width: fit-content;\n					justify-content: center;\n					align-items: center;\n					gap: 10px;\n					color: var(--desc-gray);\n					text-align: center;\n					font-family: Pretendard;\n					font-size: 12px;\n					font-style: normal;\n					font-weight: 700;\n					line-height: 150%; /* 18px */\n					letter-spacing: -0.36px;\n					padding-right: 14px;\n				}\n			}\n\n			.go-profile {\n				display: flex;\n				flex-direction: row;\n				justify-content: start;\n				align-items: center;\n				cursor: pointer;\n\n				> div {\n					color: var(--primary);\n					font-family: Pretendard;\n					font-size: 16px;\n					font-style: normal;\n					font-weight: 800;\n					line-height: 130%; /* 20.8px */\n					letter-spacing: -0.64px;\n				}\n			}\n		}\n	}\n\n	@media (max-width: 1100px) and (min-width: 800px) {\n		.profile-item {\n			/* width: 304px;\n			height: 304px; */\n			* {\n				flex-wrap: wrap;\n			}\n\n			.top-box {\n				.name {\n				}\n\n				.job {\n				}\n\n				.profile-img {\n					top: 25px;\n					width: 80px;\n					height: 80px;\n				}\n			}\n			.bottom-box {\n				.introduction {\n					/* font-size: 12px; */\n				}\n			}\n		}\n	}\n\n	@media (max-width: 1280px) {\n		.profile-item {\n			/* width: 304px; */\n			/* height: 304px; */\n\n			.top-box {\n				.name {\n				}\n\n				.job {\n				}\n\n				.profile-img {\n					/* bottom: -30px;\n					width: 60px;\n					height: 60px; */\n				}\n			}\n			.bottom-box {\n				.introduction {\n					/* font-size: 12px; */\n				}\n			}\n		}\n	}\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 12px 102px 12px 16px;\n	align-items: center;\n	border-radius: 10px;\n	background: #edf0f5;\n	flex: 1 0 0;\n	border: none;\n	color: var(--desc-gray);\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 130%; /* 20.8px */\n	letter-spacing: -0.64px;\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 12px 16px;\n	justify-content: center;\n	align-items: center;\n	gap: 10px;\n	border-radius: 10px;\n	background: var(--primary);\n	color: #fff;\n	text-align: center;\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 130%; /* 20.8px */\n	letter-spacing: -0.64px;\n	transition: transform 0.2s ease, box-shadow 0.2s ease !important;\n\n	&:hover {\n		transform: translateY(-2px);\n		box-shadow: 0px 8px 20px 0px rgba(56, 124, 246, 0.4) !important;\n	}\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	flex: 1;\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: inline-flex;\n	padding: 12px 16px;\n	justify-content: center;\n	align-items: center;\n	gap: 10px;\n	border-radius: 10px;\n	background: var(--primary);\n	color: #fff;\n	text-align: center;\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 130%; /* 20.8px */\n	letter-spacing: -0.64px;\n	transition: transform 0.2s ease, box-shadow 0.2s ease !important;\n\n	&:hover {\n		transform: translateY(-2px);\n		box-shadow: 0px 8px 20px 0px rgba(56, 124, 246, 0.4) !important;\n	}\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	font-size: 20px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 150%; /* 30px */\n	letter-spacing: -0.8px;\n\n	@media screen and (max-width: 1023px) {\n		font-size: 16px;\n	}\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin-left: 0px;\n	padding-left: 20px;\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--desc-gray);\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 150%; /* 24px */\n	letter-spacing: -0.64px;\n	list-style: disc;\n"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	.swiper-pagination-bullet-active {\n		background-color: var(--card-bg) !important;\n	}\n"
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	gap: 8px;\n	picture {\n		width: calc(25% - 10px);\n		display: flex;\n		flex-direction: row;\n		justify-content: center;\n		align-items: center;\n		img {\n			width: 100%;\n		}\n	}\n\n	@media screen and (max-width: 1023px) {\n		gap: 8px;\n		picture {\n			width: calc(50% - 10px);\n			max-width: 200px;\n			display: flex;\n			flex-direction: row;\n			justify-content: center;\n			align-items: center;\n			img {\n				width: 100%;\n			}\n		}\n	}\n"
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	max-width: 100%;\n	padding: 10px;\n\n	.swiper {\n		width: 100%;\n		height: auto;\n		min-height: 380px;\n	}\n\n	.swiper-pagination-bullet-active {\n		background-color: var(--card-bg) !important;\n	}\n"
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	width: 320px;\n	padding: 40px 20px;\n	flex-direction: column;\n	align-items: flex-start;\n	gap: 10px;\n	border-radius: 4px;\n	/* background: #f8f9fb; */\n\n	.title {\n		color: var(--desc-gray);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 150%; /* 36px */\n		letter-spacing: -0.96px;\n		width: 100%;\n	}\n\n	.num {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 40px;\n		font-style: normal;\n		font-weight: 800;\n		line-height: 116%; /* 55.68px */\n		letter-spacing: -1.92px;\n	}\n\n	.numstr {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 32px;\n		font-style: normal;\n		font-weight: 800;\n		line-height: 130%; /* 41.6px */\n		letter-spacing: -1.28px;\n	}\n\n	.desc {\n		color: var(--desc-gray);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n		width: 100%;\n	}\n\n	@media (max-width: 1023px) {\n		padding: 30px 20px;\n		.title {\n			font-size: 20px;\n		}\n\n		.num {\n			font-size: 32px;\n		}\n\n		.numstr {\n			font-size: 32px;\n		}\n\n		.desc {\n			font-size: 20px;\n		}\n	}\n"
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: calc(33% - 8px);\n	flex-shrink: 0;\n	border-radius: 16px;\n	overflow: hidden;\n	display: flex;\n	flex-direction: column;\n	justify-content: flex-end;\n	cursor: pointer;\n	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);\n	transition: transform 0.25s ease, box-shadow 0.25s ease;\n\n	&:hover {\n		transform: translateY(-6px);\n		box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.13);\n	}\n\n	.img {\n		width: 100%;\n	}\n\n	.title {\n		color: var(--card-bg);\n		font-size: 19px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 26px */\n		letter-spacing: -0.6px;\n	}\n\n	.card {\n		display: inline-flex;\n		padding: 4px 8px;\n		justify-content: center;\n		align-items: center;\n		gap: 10px;\n		border-radius: 4px;\n		background: var(--bg-white);\n		color: var(--desc-gray);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 12px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 150%; /* 18px */\n		letter-spacing: -0.36px;\n	}\n"
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 440px;\n	height: 564px;\n	flex-shrink: 0;\n	border-radius: 16px;\n	overflow: hidden;\n	border: 1px solid rgba(0, 0, 0, 0.06);\n	background: #fff;\n	flex-grow: 0;\n	flex-shrink: 0;\n	cursor: pointer;\n	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);\n	transition: transform 0.25s ease, box-shadow 0.25s ease;\n\n	&:hover {\n		transform: translateY(-6px);\n		box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.13);\n	}\n\n	.thumb {\n		width: 440px;\n		flex-shrink: 0;\n	}\n\n	.tag {\n		display: inline-flex;\n		padding: 4px 8px;\n		justify-content: center;\n		align-items: center;\n		gap: 10px;\n		border-radius: 4px;\n		background: var(--bg-white);\n		color: var(--desc-gray);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 12px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 150%; /* 18px */\n		letter-spacing: -0.36px;\n	}\n\n	.title {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 20.8px */\n		letter-spacing: -0.48px;\n	}\n\n	.name {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 12px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 18px */\n		letter-spacing: -0.48px;\n	}\n	.text {\n		color: var(--desc-gray);\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n	}\n"
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 260px;\n	height: 280px;\n	flex-shrink: 0;\n	border-radius: 16px;\n	overflow: hidden;\n	border: 1px solid rgba(0, 0, 0, 0.06);\n	background: #fff;\n	cursor: pointer;\n	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);\n	transition: transform 0.25s ease, box-shadow 0.25s ease;\n\n	&:hover {\n		transform: translateY(-6px);\n		box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.13);\n	}\n\n	.thumb {\n		width: 260px;\n		flex-shrink: 0;\n	}\n\n	.tag {\n		display: inline-flex;\n		padding: 4px 8px;\n		justify-content: center;\n		align-items: center;\n		gap: 10px;\n		border-radius: 4px;\n		background: var(--bg-white);\n		color: var(--desc-gray);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 12px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 150%; /* 18px */\n		letter-spacing: -0.36px;\n	}\n\n	.title {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 20.8px */\n		letter-spacing: -0.48px;\n	}\n\n	.name {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 12px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 18px */\n		letter-spacing: -0.48px;\n	}\n"
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	border: none;\n	background-color: white;\n	width: 100%;\n	transition: all 0.2s ease-in-out;\n\n	&:hover {\n		background-color: #f5f5f5;\n	}\n\n	&.MuiAccordion-root {\n		&:before {\n			background-color: transparent !important;\n		}\n	}\n\n	@media screen and (max-width: 1023px) {\n		.MuiAccordionSummary-root {\n			font-size: 14px;\n		}\n	}\n"
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 120%; /* 19.2px */\n	letter-spacing: -0.48px;\n"
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	text-align: right;\n	font-family: Pretendard;\n	font-size: 40px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 48px */\n	letter-spacing: -1.2px;\n"
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	text-align: right;\n	font-family: Pretendard;\n	font-size: 24px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 28.8px */\n	letter-spacing: -0.72px;\n"
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--desc-gray);\n	font-family: Pretendard;\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 130%; /* 19.2px */\n	letter-spacing: -0.64px;\n"
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	font-size: 40px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%;\n	letter-spacing: -2.24px;\n\n	.blue {\n		color: #387cf6;\n	}\n"
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: black;\n	font-size: 14px;\n	cursor: pointer;\n\n	&:hover {\n		color: #0378ef !important;\n	}\n"
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	gap: 8px;\n	flex-basis: calc(33% - 19px);\n\n	.responsibility-img {\n		width: 56px;\n		height: 56px;\n	}\n\n	.title {\n		color: var(--card-bg);\n		font-size: 24px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 31.2px */\n		letter-spacing: -0.72px;\n		letter-spacing: -0.48px;\n	}\n\n	.desc {\n		color: var(--desc-gray);\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n	}\n\n	@media screen and (max-width: 1024px) {\n		width: 100%;\n		max-width: 300px;\n\n		.title {\n			font-size: 20px;\n		}\n		.desc {\n			font-size: 16px;\n		}\n	}\n"
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}







var FAQAnswerDiv2 = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());
var FAQAnswerDiv = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject1());
var CtaImageBox = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject2());
var MainCtaButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject3());
var MainCtaButtonOutlined = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject4());
var ExpertMainCtaButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject5());
var ExpertMainCtaButtonMobile = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject6());
var BlogCtaButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject7());
var MainCtaContentsInner = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject8());
var slideUpFade = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .keyframes */ .F4)(_templateObject9());
var RollingTextSpan = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .Z.span(_templateObject10(), slideUpFade);
var ExpertCtaContentsInner = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject11());
var ExpertCtaContentsInnerMobile = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject12());
var MainCtaContentsContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject13());
var ExpertCtaContentsContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject14());
var WhyCardList = [
    {
        imgSrc: "/onepoint/images/renewal/why-section/why1.png",
        title: "정규직 채용이 부담스러워요",
        subTitle: "잘하는 마케터가 필요하나 파트타임을 원하거나,\n사업 변동성이 커서 유연한 고용이 필요할 때"
    },
    {
        imgSrc: "/onepoint/images/renewal/why-section/why2.png",
        title: "신규 전략 수립이 필요합니다",
        subTitle: "대행사가 깊이 고민해주지 않아서 아쉽거나,\n새로운 전략 수립이 필요하나 CMO가 없을 때"
    },
    {
        imgSrc: "/onepoint/images/renewal/why-section/why3.png",
        title: "내부 역량 강화를 원합니다",
        subTitle: "대표/임원이 직접 배워 시스템을 구축하고 싶거나, 내부 주니어 마케터의 사수가 필요할 때"
    },
    {
        imgSrc: "/onepoint/images/renewal/why-section/why4.png",
        title: "특정 전문성이 단기로 필요합니다",
        subTitle: "새로운 시도를 위해 특정 스킬/경험이 필요하거나, 기존 마케팅 방식과 시스템을 점검받고 싶을 때"
    }, 
];
var WhyCard = function(props) {
    var imgSrc = props.imgSrc, title = props.title, subTitle = props.subTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WhyCardBox, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                style: {
                    width: "56px",
                    height: "56px"
                },
                src: imgSrc,
                alt: ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .GroupA */ .so, {
                order: "column-start-start",
                gap: 8,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "subTitle",
                        children: subTitle
                    })
                ]
            })
        ]
    });
};
var ProcessCardList = [
    {
        imgSrc: "/onepoint/images/renewal/process/process_1.png",
        title: "매칭 컨설팅",
        subTitle: "마케터 출신의 매칭 컨설턴트와 요청 업무에 대해 논의합니다."
    },
    {
        imgSrc: "/onepoint/images/renewal/process/process_2.png",
        title: "최적 매칭",
        subTitle: "개별 기업의 특성과 니즈에 맞춘 최적 전문가를 추천받습니다."
    },
    {
        imgSrc: "/onepoint/images/renewal/process/process_3.png",
        title: "인터뷰",
        subTitle: "화상 미팅을 통해 전문가의\n역량과 적극성을 검증합니다."
    },
    {
        imgSrc: "/onepoint/images/renewal/process/process_4.png",
        title: "계약",
        subTitle: "계약 사항 협의를 완료하고 전문가와 업무를 시작합니다."
    }, 
];
var ExpertProcessCardList = [
    {
        imgSrc: "/onepoint/images/renewal/expert/why-section/document.png",
        title: "서류",
        subTitle: "경력, 이력, 과거 프로젝트\n경험을 제출합니다"
    },
    {
        imgSrc: "/onepoint/images/renewal/process/process_2.png",
        title: "역량 평가",
        subTitle: "실무 역량을 검증하기 위한\n과제 평가를 진행합니다"
    },
    {
        imgSrc: "/onepoint/images/renewal/process/process_3.png",
        title: "심층 면접",
        subTitle: "소프트 스킬을 검증하기 위한\n면접을 진행합니다"
    },
    {
        imgSrc: "/onepoint/images/renewal/process/process_4.png",
        title: "계약",
        subTitle: "원포인트와 계약을 체결하면\n전문가 풀에 등록됩니다"
    }, 
];
var ExpertProcessCardListMobile = [
    {
        imgSrc: "/onepoint/images/renewal/expert/why-section/document.png",
        title: "서류",
        subTitle: "경력, 이력, 과거 프로젝트\n경험을 제출합니다"
    },
    {
        imgSrc: "/onepoint/images/renewal/process/process_2.png",
        title: "역량 평가",
        subTitle: "실무 역량을 검증하기 위한\n과제 평가를 진행합니다"
    },
    {
        imgSrc: "/onepoint/images/renewal/process/process_3.png",
        title: "심층 면접",
        subTitle: "소프트 스킬을 검증하기 위한\n면접을 진행합니다"
    },
    {
        imgSrc: "/onepoint/images/renewal/process/process_4.png",
        title: "계약",
        subTitle: "원포인트와 계약을 체결하면\n전문가 풀에 등록됩니다"
    }, 
];
var ProcessCard = function(props) {
    var imgSrc = props.imgSrc, title = props.title, subTitle = props.subTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ProcessCardBox, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                src: imgSrc,
                alt: "",
                style: {
                    width: "56px",
                    height: "56px"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .Empty */ .HY, {
                space: 16
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "title",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .Empty */ .HY, {
                space: 8
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "subTitle",
                children: subTitle
            })
        ]
    });
};
var ExpertProcessCard = function(props) {
    var imgSrc = props.imgSrc, title = props.title, subTitle = props.subTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ExpertProcessCardBox, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                src: imgSrc,
                alt: "",
                style: {
                    width: "56px",
                    height: "56px"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .Empty */ .HY, {
                space: 16
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "title",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_4__/* .Empty */ .HY, {
                space: 8
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "subTitle",
                children: subTitle
            })
        ]
    });
};
var WhyCardBox = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject15());
var ExpertProcessCardBox = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject16());
var ProcessCardBox = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject17());
var ConsultantCardListBox = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject18());
var ReviewCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject19());
var ExpertReviewCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject20());
var ConsultantCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject21());
var MainContentsContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject22());
var ExpertMainContentsContainerMobile = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject23());
var ContentsContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section */ .Z.section(_templateObject24());
var ContentsContainerMobile = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section */ .Z.section(_templateObject25());
var SectionTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject26());
var SectionTitlePrimary = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject27());
var SectionTitleMobile = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject28());
var SectionLargeTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject29());
var SectionTitleLeft = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject30());
var SectionTitleLeftDirect = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject31());
var SectionSubTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject32());
var SectionSubTitleMobile = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject33());
var SectionSmallTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject34());
var HowtoSectionSmallTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject35());
var SectionSmallSubTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject36());
var SectionSmallSubTitle2 = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject37());
var WhyOnePointBox = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject38());
var WhyOnePointDiv = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject39());
var profileDataArray = [
    {
        name: "hani",
        job: "콘텐츠\xb7브랜드 마케터 7년차",
        introduction: "다양한 규모의 인하우스 경험을 바탕으로\n온\xb7오프라인 브랜드 마케팅 전략과 실무를\n모두 수행하는 전략형 마케터",
        tagList: [
            "뷰티/화장품",
            "라이프스타일",
            "F&B",
            "SaaS"
        ],
        skillList: [
            "Google",
            "Meta",
            "LinkedIn",
            "네이버",
            "카카오",
            "콘텐츠 기획"
        ],
        imageUrl: "/onepoint/assets/images/main/profile/hani.jpg",
        profileUrl: "https://notion.1point.kr/expert/profile/hani"
    },
    {
        "name": "강제인",
        "job": "콘텐츠 마케터 9년차",
        "introduction": "브랜드 맥락을 기반으로\n콘텐츠와 크리에이티브를 설계하고\n성과로 연결하는 콘텐츠 마케터",
        "tagList": [
            "여행/레저",
            "교육",
            "SaaS",
            "플랫폼"
        ],
        "skillList": [
            "콘텐츠 기획/전략",
            "소재/상세 페이지 기획",
            "Figma",
            "Meta"
        ],
        "imageUrl": "/onepoint/assets/images/main/profile/kangjane.jpg",
        "profileUrl": "https://notion.1point.kr/expert/profile/kangjane"
    },
    {
        name: "댄디라이언",
        job: "콘텐츠 마케터 14년차",
        introduction: "기획부터 디자인\xb7제작까지 전 과정을 아우르며\n감각적인 콘텐츠로 브랜드 스토리를 만드는\n올인원 콘텐츠\xb7브랜딩 마케터",
        tagList: [
            "레저",
            "여행/아웃도어/부동산",
            "스포츠/패션",
            "자동차"
        ],
        skillList: [
            "바이럴 마케팅",
            "콘텐츠 마케팅",
            "Meta",
            "네이버 SNS"
        ],
        imageUrl: "/onepoint/assets/images/main/profile/dandylion.jpg",
        profileUrl: "https://notion.1point.kr/expert/profile/dandylion"
    },
    {
        name: "루시",
        job: "퍼포먼스 마케터 9년차",
        introduction: "콘텐츠\xb7브랜딩\xb7퍼포먼스를 아우르는\n경험과 10명 규모 팀 리딩 경험을 보유한\n시니어 퍼포먼스 마케터",
        tagList: [
            "뷰티/화장품",
            "패션",
            "앱 ",
            "SNS",
            "글로벌"
        ],
        skillList: [
            "Google",
            "Meta",
            "네이버",
            "카카오",
            "퍼포먼스 전략", 
        ],
        imageUrl: "/onepoint/assets/images/main/profile/lucy.jpg",
        profileUrl: "https://notion.1point.kr/expert/profile/lucy"
    },
    // {
    // 	name: "제이",
    // 	job: "그로스 마케터 11년차",
    // 	introduction:
    // 		"재미와 의미가 있는 일을 찾아\n문제를 정의하고 해결하는\n11년차 그로스 마케터",
    // 	tagList: ["커머스", "인사/비즈니스", "교육"],
    // 	skillList: ["마케팅전략", "데이터분석", "Meta", "Google"],
    // 	imageUrl: "/onepoint/assets/images/main/profile/jay.jpg",
    // 	profileUrl: "https://notion.1point.kr/expert/profile/jay",
    // },
    // {
    // 	name: "데이",
    // 	job: "퍼포먼스 마케터 10년차",
    // 	introduction: "Meta 전문, 커머스 전문\n10년차 퍼포먼스마케터\n\n",
    // 	tagList: ["패션", "홈리빙/생활용품", "유아동"],
    // 	skillList: ["Meta", "네이버", "카카오"],
    // 	imageUrl: "/onepoint/assets/images/main/profile/day.jpg",
    // 	profileUrl: "https://notion.1point.kr/expert/profile/day",
    // },
    {
        name: "M-J",
        job: "퍼포먼스 마케터 7년차",
        introduction: "서비스 중심 B2C부터\n채용/교육/SaaS 분야 B2B까지\n다양한 광고 운영 이력의 전문 마케터",
        tagList: [
            "솔루션",
            "교육",
            "인사/비즈니스"
        ],
        skillList: [
            "GA/GTM",
            "마케팅전략",
            "데이터분석"
        ],
        imageUrl: "/onepoint/assets/images/main/profile/mj.jpg",
        profileUrl: "https://notion.1point.kr/expert/profile/mj"
    },
    // {
    // 	name: "Max",
    // 	job: "PM/PO 5년차",
    // 	introduction:
    // 		"브랜드 운영에 최적화된 이력과\n세일즈&광고 구조화 역량을 갖춘\n올라운더 프로젝트 리더",
    // 	tagList: ["커머스", "뷰티/화장품", "헬스케어/바이오"],
    // 	skillList: ["광고구조화", "콘텐츠기획", "프로젝트리딩"],
    // 	imageUrl: "/onepoint/assets/images/main/profile/son.jpeg",
    // 	profileUrl: "https://notion.1point.kr/expert/profile/max",
    // },
    // {
    // 	name: "Claire",
    // 	job: "그로스 마케터 12년차",
    // 	introduction:
    // 		"글로벌 대기업부터 스타트업까지\n다양한 마케팅 리드 경험으로\n딱 필요한 마케팅 전략을 제시하는 전문가",
    // 	tagList: ["헬스케어/바이오", "컨텐츠/예술", "제조/하드웨어"],
    // 	skillList: ["마케팅전략", "브랜드전략", "SEM"],
    // 	imageUrl: "/onepoint/assets/images/main/profile/claire.jpg",
    // 	profileUrl: "https://notion.1point.kr/expert/profile/claire",
    // },
    {
        name: "hidy",
        job: "그로스 마케터 7년차",
        introduction: "유입부터 재구매까지\n비즈니스의 성장에 필요한 A to Z를\n디스커션 할 수 있는 시니어 마케터",
        tagList: [
            "커머스",
            "패션",
            "뷰티/화장품"
        ],
        skillList: [
            "소재기획",
            "이미지/영상제작",
            "콘텐츠기획"
        ],
        imageUrl: "/onepoint/assets/images/main/profile/hidy.jpg",
        profileUrl: "https://notion.1point.kr/expert/profile/hidy"
    }
];
var SwiperSectionContents = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ContentsContainer)(_templateObject40());
var SubscribeInput = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input */ .Z.input(_templateObject41());
var SubscribeButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_lab__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_templateObject42());
var SectionRight = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject43());
var FAQButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject44());
var FAQAnswerTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject45());
var AnswerListUl = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ul */ .Z.ul(_templateObject46());
var FAQAnswerList = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].li */ .Z.li(_templateObject47());
var ConsultantUserList = [
    {
        imgSrc: "/onepoint/images/consultant/jeon.jpg",
        name: "전준현",
        desc: "퍼포먼스 마케터 2년차"
    }, 
];
var CListPagination = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject48());
var CIListContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject49());
var ReviewContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject50());
var ReviewData = [
    {
        title: "업계 최고 수준의 마케터를 필요할 때마다 합리적으로",
        description: "원포인트는 업계 최고 수준의 마케터를, 필요할 때마다 합리적인 가격으로 활용할 수 있는 서비스입니다.",
        company: "아파트멘터리",
        name: "하아얀",
        position: "전략실장",
        img: "/onepoint/images/renewal/review-section/1-1.png"
    },
    {
        title: "마케팅, 헤매지 않고 시작하는 법",
        description: "신규 조직에 내부 전담 인력이 없는 상태에서 GA세팅부터 광고 운영까지, 성공적으로 디지털 마케팅을 시작할 수 있었습니다. 단순 운영 대행이 아닌, 함께 고민하는 파트너와 일하는 것 같아 정말 좋았습니다.",
        company: "한화솔루션",
        name: "김수현",
        position: "프로",
        img: "/onepoint/images/renewal/review-section/1-2.png"
    },
    {
        title: "전문가 퀄리티에 놀랐습니다",
        description: "저희가 쉽게 채용할 수 없는 분과, 원하는 기간 만큼만 함께 일할 수 있어서 좋았고 큰 도움을 받았습니다. 특히 전문가 퀄리티에 놀랐습니다.",
        company: "샐러디",
        name: "이건호",
        position: "대표",
        img: "/onepoint/images/renewal/review-section/1-3.png"
    },
    {
        title: "초기 스타트업에게 최고의 선택",
        description: "마케터가 필요하지만 정규직 고용은 부담스럽다보니 원포인트를 통해 파트타임 전문가를 고용했습니다. 시간내에 큰 성과를 내기 위해 진심으로 일해주시는 역량있는 마케터를 만나서 많은 도움이 되었습니다.",
        company: "패러닷",
        name: "장진욱",
        position: "대표",
        img: "/onepoint/images/renewal/review-section/1-4.png"
    },
    {
        title: "정규직 채용과 외주 활용 부담을 해결했어요",
        description: "정규직을 채용하기에는 제약이 많고, 검증되지 않은 곳에 외주를 맡기기도 부담스러웠습니다. 원포인트를 통해 시간제로 역량있는 마케터와 일할 수 있어 이러한 갈증이 해결되었습니다.",
        company: "셀러노트",
        name: "이종원",
        position: "대표",
        img: "/onepoint/images/renewal/review-section/1-5.png"
    },
    {
        title: "비용이 반으로 줄었는데 성과가 개선됐어요",
        description: "마케터 채용 비용의 50%로 실적은 계속적으로 향상되고 있어요! 좋은 시니어 마케터분을 찾으신다면 관리까지 꼼꼼하게 해주는 원포인트 추천합니다!",
        company: "소프트스퀘어드",
        name: "윤수진",
        position: "",
        img: "/onepoint/images/renewal/review-section/1-6.png"
    },
    {
        title: "더 이상 헤매지 않고 마케팅을 하게 되었습니다",
        description: "마케팅은 경험이 중요하다고 생각합니다. 고급 숙련자의 경험을 바탕으로 마케팅을 진행하고 배울 수 있어서 추천합니다. 더 이상 주니어들끼리 헤매지 않아도 됩니다.",
        company: "투어라이브",
        name: "노경아",
        position: "대표",
        img: "/onepoint/images/renewal/review-section/1-7.png"
    },
    {
        title: "광고 성과가 많이 올랐습니다",
        description: "실력있는 인재와 함께하는 것이 좋은 성과의 핵심인데, 원포인트에서 만난 마케팅 전문가님의 도움으로 성과가 많이 올랐습니다",
        company: "펫박스",
        name: "이현석",
        position: "대표",
        img: "/onepoint/images/renewal/review-section/1-8.png"
    },
    {
        title: "더 이상 대행사를 쓰지 않습니다",
        description: "마케팅 대행사를 세 곳 정도 써보았지만 모두 마음에 들지 않았습니다. 결국 지금은 원포인트를 통해 숙련된 퍼포먼스 마케터를 파트타임으로 활용하고 있는데, 알아서 캠페인 퍼포먼스 관리를 잘 해주시니 정말 편리합니다.",
        company: "에딧메이트",
        name: "최범익",
        position: "대표",
        img: "/onepoint/images/renewal/review-section/1-9.png"
    }, 
];
var ExpertReviewData = [
    {
        title: "원포인트와 함께\n새로운 도전을 하고 있어요",
        description: "원포인트로 얻는 수익이 안정적인데다가 제 커리어와 fit한 신규 고객사를 꾸준히 제안주시다보니, 용기내어 퇴사를 결심할 수 있게 되었어요. 제가 편한 시간에 자유롭게 근무할 수 있음에 감사하고 있어요.",
        position: "퍼포먼스 마케터",
        name: "Day"
    },
    {
        title: "관심있는 분야의 \n스타트업을 경험했어요",
        description: "프롭테크에 관심이 많아서 이직을 고려하고 있었어요. 이 점을 고려해서 매칭을 해달라고 부탁드렸었고, 정말 관련 스타트업과 일할 수 있었습니다.",
        position: "브랜드 마케터",
        name: "자몽"
    },
    {
        title: "초기 스타트업을 성장시키는 \n뿌듯함을 느끼고 있어요",
        description: "규모가 큰 회사에 다니다 보니까 매번 똑같은 일만 하고 있었는데요. 원포인트를 통해서 초기 스타트업을 도와드리게 되었어요. 저를 통해 비즈니스가 성장하는 걸 보면 정말 보람있습니다.",
        position: "그로스 마케터",
        name: "Ryan"
    },
    {
        title: "제가 가진 스킬로\n부수입을 만들고 있어요",
        description: "원래 제가 잘 알고 있는 스킬들을 활용하여 추가 수입을 만들 수 있다는 것이 가장 큰 장점입니다. 또한, 다양한 업계의 클라이언트를 만날 수 있어서 더 많은 경험을 통한 인사이트를 쌓을 수 있습니다.",
        position: "퍼포먼스 마케터",
        name: "루시"
    },
    {
        title: "확신을 가지고 프리랜서로\n전향할 수 있었습니다",
        description: "늘 디지털 노마드가 되는게 목표였습니다. 그러다가 원포인트를 만났습니다. 조금씩 담당하는 고객사를 늘리다가 이제는 아예 프리랜서로 전향했습니다.",
        position: "카피라이터",
        name: "Zero"
    },
    {
        title: "원포인트 덕에\n편하게 사이드잡을!",
        description: "저에게 딱 맞는 고객사분들 추천해주셔서 마음껏 마케팅 일하고 돈벌고 있습니다. 원포인트가 있어서 안심하고 있으며 편하게 사이드잡합니다! 계속해서 고객사와 마케터를 연결해주는 좋은 플랫폼으로 남아주세요!",
        position: "퍼포먼스 마케터",
        name: "유진"
    },
    {
        title: "제 가치를\n인정 받고 있어요",
        description: "디자인 시장은 워낙 저렴한 가격에 진행하는 곳이 많아서 돈을 많이 벌 수 없었어요. 하지만 원포인트의 전문가는 기본적으로 고객사가 신뢰하고 있어서 제 가치에 맞는 보수를 받을 수 있었습니다.",
        position: "디자이너",
        name: "Ace"
    },
    {
        title: "다양한 업무 경험에\n부수입까지!",
        description: "다양한 업종의 마케팅을 경험할 수 있고, 자신이 노력한 한 만큼 부수입도 얻을 수 있어 일이 재미있다고 느끼실 수 있을 것 같아요. 주어지는 회사 업무만으로 만족하지 못하는, 열정이 넘치는 마케터들에게 적극 추천합니다.",
        position: "마케팅 디렉터",
        name: "하슬기"
    },
    {
        title: "고객사와 마케터를 위한\n가장 합리적 선택입니다",
        description: "고객사분들께서는 마케터를 고용하기에는 높은 임금이 부담스러운 문제를 해결해주고, 대행사 및 인하우스 마케터는 원포인트를 통해 다양한 브랜드 경험과 함께 부가적인 수익을 얻으면서 자부심까지 상승하는 것 같습니다.",
        position: "퍼포먼스 마케터",
        name: "범쌤"
    },
    {
        title: "다양한 프로젝트를 통해\n포트폴리오가 풍부해졌어요",
        description: "회사 업무 외에도 다양한 프로젝트를 맡아 진행할 수 있어 부족한 포트폴리오를 채우는 데 도움이 많이 됩니다. 특히 고객사들이 초기 스타트업들이 많아 제 의견을 적극적으로 수용해주셔서 하고 싶은 프로젝트를 재미있게 하고 있어요.",
        position: "콘텐츠 마케터",
        name: "Yonna"
    },
    {
        title: "최적의 업무 환경에서\n일할 수 있어요",
        description: "재택으로 일할 수 있는 점이 가장 큰 매력이에요. 또한 업무 시간, 협업 방식 역시 유연하게 조정할 수 있어서 업무 생산성도 높아지는 것 같습니다. 마케터에게는 최적의 업무 환경인 것 같아요.",
        position: "마케팅 디렉터",
        name: "클레어"
    },
    {
        title: "타서비스 대비 \n매칭 만족도가 높아요",
        description: "원포인트는 내가 가진 전문역량을 활용하여 높은 수준의 부수입을 만들 수 있는 가장 쉬운 방법입니다. 타서비스와 비교할 수 없을 만큼 고객사의 니즈를 구체적으로 전달해주시고 빠르게 소통해주셔서 매칭 만족도와 성사율도 높습니다.",
        position: "그로스 마케터",
        name: "레비"
    }, 
];
var ExpertTrustCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject51());
var TrustData = [
    {
        title: "국내 프리랜서 마케터 플랫폼",
        num: "1",
        numstr: "위"
    },
    {
        title: "원포인트 전문가 월 평균 수입",
        num: "264만원",
        numstr: "+"
    },
    {
        title: "원포인트와 함께하는 전문가",
        num: "800명",
        numstr: "+"
    }, 
];
var BpCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject52());
var BpList = [
    {
        name: "마케팅 캠페인",
        title: "샐러디는 어떻게 배달앱 인기 검색어 1위에 올랐을까?",
        imgSrc: "/onepoint/assets/images/main/example/bp_salady.png",
        url: "https://1point.kr/blog/best-practices/salady/"
    },
    {
        name: "콘텐츠 마케팅",
        title: "580억 투자 받은 아파트멘터리가 잘하는 마케터 고용한 방법",
        imgSrc: "/onepoint/assets/images/main/example/bp_ap.png",
        url: "https://1point.kr/blog/best-practices/apartmentary/"
    },
    {
        name: "콘텐츠 마케팅",
        title: "MZ세대 대세 서비스 패러닷이\n대박 콘텐츠를 만들어낸 노하우",
        imgSrc: "/onepoint/assets/images/main/example/paradot.png",
        url: "https://1point.kr/blog/best-practices/paradot/"
    },
    {
        name: "퍼포먼스 마케팅",
        title: "트렌드아이는 어떻게 마케터 채용에\n드는 시간과 비용을 줄였을까?",
        imgSrc: "/onepoint/assets/images/main/example/bp_wdressroom.png",
        url: "https://1point.kr/blog/best-practices/trend-i/"
    },
    {
        name: "그로스 마케팅",
        title: "초기 스타트업 리클이\n경력직 마케터 채용 대신 선택한 것",
        imgSrc: "/onepoint/assets/images/main/example/bp_recl.png",
        url: "https://1point.kr/blog/best-practices/recl/"
    },
    {
        name: "브랜드 마케팅",
        title: "닥터이브가 마케터 정규직 없이\n3개월만에 매출 월 1억을 달성한 방법",
        imgSrc: "/onepoint/assets/images/main/example/purposed-dreve.png",
        url: "https://1point.kr/blog/best-practices/purposed-dreve/"
    }, 
];
var BigInsightCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject53());
var InsightCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject54());
var InsightList = [
    {
        name: "연준현",
        title: "초기 스타트업을 위한 마케팅 가이드",
        type: "인사이트",
        imgSrc: "/onepoint/images/renewal/insight-section/1.png",
        url: "https://1point.kr/blog/insights/startup-marketing-guide/",
        text: "초기 스타트업, 어떤 마케팅을 해야 할까요? 라이브 커머스, SEO/SEM, 퍼포먼스, 그로스, 브랜드, 이메일, CPA, 트래픽, 제휴, 콘텐츠 등 이 많은 마케팅 방법 중 초기 스타트업은 어떤 것을 선택해야 할지 목적과 수단에 따른 마케팅에 대해 알아봅니다."
    },
    {
        name: "레비",
        title: "개발 지식 없이 페이스북 픽셀\n설치하는 법",
        type: "인사이트",
        imgSrc: "/onepoint/images/renewal/insight-section/2.png",
        url: "https://1point.kr/blog/insights/meta-pixel-1/"
    },
    {
        name: "데이",
        title: "인스타 광고 vs 메타 광고\n3가지 차이점 탐구",
        type: "인사이트",
        imgSrc: "/onepoint/images/renewal/insight-section/3.png",
        url: "https://1point.kr/blog/insights/instagram-vs-meta/"
    },
    {
        name: "콘텐츠온",
        title: "B2B 마케팅에서 고객을\n효과적으로 설득하는 방법",
        type: "인사이트",
        imgSrc: "/onepoint/images/renewal/insight-section/4.png",
        url: "https://1point.kr/blog/insights/b2b-success-cases/"
    },
    {
        name: "Miguel",
        title: "퍼포먼스 마케팅 vs 그로스 마케팅,\n차이점과 적용 시기",
        type: "인사이트",
        imgSrc: "/onepoint/images/renewal/insight-section/5.png",
        url: "https://1point.kr/blog/insights/growth-performance-difference/"
    }, 
];
var CustomAccordion = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_templateObject55());
var PentagonSubTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject56());
var PentagonTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject57());
var PentagonTitle2 = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject58());
var HowToVerifyStepTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject59());
var HowToVerrifyBigTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject60());
var CustomA = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].a */ .Z.a(_templateObject61());
var ExpertWhyOnpointData = [
    {
        label: "수익 창출",
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    className: "bold",
                    children: "잘하는 일"
                }),
                "로",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    className: "bold",
                    children: "부수입"
                }),
                "을 만드세요"
            ]
        }),
        description: "그동안 힘들게 쌓아오신 역량을\n수익화 할 수 있는 기회입니다",
        image: "/onepoint/images/renewal/expert/why-section/money.png"
    },
    {
        label: "유연함",
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                "잘 맞는 고객사와",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    className: "bold",
                    children: "원하는 업무만 하세요"
                })
            ]
        }),
        description: "프로필 전체 공개없이\n희망하는 업무만 골라 지원할 수 있습니다",
        image: "/onepoint/images/renewal/expert/why-section/match.png"
    },
    {
        label: "다양한 경험",
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    className: "bold",
                    children: "본업 외 분야"
                }),
                "에서",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    className: "bold",
                    children: "성과"
                }),
                "를 만드세요"
            ]
        }),
        description: "본업 외 분야에 새롭게 도전하며\n자극받고 성장할 수 있습니다",
        image: "/onepoint/images/renewal/expert/why-section/mountain.png"
    }, 
];
var ResponsibilityData = [
    {
        title: "전문가 개인 정보는\n철저하게 지켜요",
        desc: "닉네임 사용, 전문가 동의 없이\n신상정보 미공개, 비밀유지 NDA 체결",
        image: "/onepoint/images/renewal/expert/why-section/lock.png"
    },
    {
        title: "번거로운 작업은\n원포인트가 책임질게요",
        desc: "계약, 단가 협의, 일정 변경, 사후 조율 등의 물리적, 심리적으로 부담스러운 업무",
        image: "/onepoint/images/renewal/expert/why-section/cal.png"
    },
    {
        title: "전문가 대금은\n안전하게 지급해요",
        desc: "대금 선수취로 미지급 걱정 없이 정해진\n일자에 약속된 대금 지급",
        image: "/onepoint/images/renewal/expert/why-section/calendar.png"
    }, 
];
var ResponsibilityCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject62());


/***/ }),

/***/ 70436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ MainContentsMobile; },
/* harmony export */   "Y": function() { return /* binding */ CustomA; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70917);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var _mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(23508);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(52029);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(61225);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(54225);
/* harmony import */ var _mui_material_Accordion__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(76992);
/* harmony import */ var _mui_material_AccordionDetails__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(47028);
/* harmony import */ var _mui_material_AccordionSummary__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(29618);
/* harmony import */ var _src_api_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67514);
/* harmony import */ var _src_api_sign__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28702);
/* harmony import */ var _src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76445);
/* harmony import */ var _src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34489);
/* harmony import */ var _src_hook_useUser__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92859);
/* harmony import */ var _src_model_applicationModel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21594);
/* harmony import */ var _src_ruix__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9869);
/* harmony import */ var _src_state__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51413);
/* harmony import */ var _src_utils_sign__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(57386);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67294);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1785);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react_gtm_module__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4480);
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(94135);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(48929);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					.how-to-verify {\n						border-radius: 20px;\n						overflow: hidden;\n						transition: transform 0.2s ease;\n					}\n				"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 19.2px */\n	letter-spacing: -0.48px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	text-align: right;\n	font-family: Pretendard;\n	font-size: 48px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 57.6px */\n	letter-spacing: -1.44px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	text-align: right;\n	font-family: Pretendard;\n	font-size: 24px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 28.8px */\n	letter-spacing: -0.72px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	flex: 1;\n	height: 125px;\n	position: relative;\n	width: 100%;\n\n	> .column-start-start {\n		z-index: 1;\n	}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	background-color: ",
        ";\n	color: white;\n	font-weight: bold;\n	width: ",
        ";\n	height: ",
        ";\n	clip-path: polygon(\n		0% 0%,\n		100% 0%,\n		",
        " 100%,\n		0% 100%\n	);\n	display: flex;\n	justify-content: center;\n	align-items: center;\n	position: absolute;\n	top: 0;\n	left: 0;\n\n	@media screen and (max-width: 620px) {\n		display: none;\n	}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--desc-gray);\n	font-family: Pretendard;\n	font-size: 14px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 120%; /* 19.2px */\n	letter-spacing: -0.48px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	font-size: 24px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%;\n	letter-spacing: -2.24px;\n\n	.blue {\n		color: #387cf6;\n	}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: black;\n	font-size: 14px;\n	cursor: pointer;\n\n	&:hover {\n		color: #0378ef !important;\n	}\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--primary);\n	font-size: 14px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 150%; /* 24px */\n	letter-spacing: -0.64px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--desc-gray);\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 150%; /* 24px */\n	letter-spacing: -0.64px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--desc-gray);\n	font-size: 14px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 150%; /* 24px */\n	letter-spacing: -0.64px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: absolute;\n	padding: 4px;\n	border-radius: 4px;\n	background: #f6f7f8;\n\n	box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.04);\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 12px 24px;\n	justify-content: center;\n	align-items: center;\n	gap: 10px;\n	border-radius: 12px;\n	color: #fff;\n	text-align: center;\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 130%; /* 31.2px */\n	letter-spacing: -0.96px;\n	width: 200px;\n	box-shadow: 0px 6px 20px 0px rgba(56, 124, 246, 0.2);\n	transition: transform 0.2s ease, box-shadow 0.2s ease !important;\n\n	&:hover {\n		transform: translateY(-2px);\n		box-shadow: 0px 10px 28px 0px rgba(56, 124, 246, 0.3) !important;\n	}\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 12px 20px;\n	justify-content: center;\n	align-items: center;\n	gap: 10px;\n	min-width: fit-content;\n	border-radius: 4px;\n	background-color: var(--card-bg);\n\n	&:hover {\n		background-color: var(--bg);\n	}\n\n	color: white;\n	text-align: center;\n	font-size: 14px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 130%; /* 20.8px */\n	letter-spacing: -0.48px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	gap: 0px;\n\n	.cta-title-box {\n		span {\n			color: var(--card-bg);\n			text-align: center;\n			font-size: 28px;\n			font-style: normal;\n			font-weight: 800;\n			line-height: 116%; /* 55.68px */\n			letter-spacing: -1.92px;\n		}\n		.blue {\n			color: var(--primary);\n		}\n	}\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding-top: 60px;\n	padding-bottom: 0px;\n	width: 100%;\n	position: relative;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex: 1;\n	padding: 16px 10px;\n	width: 100%;\n	align-items: flex-start;\n	gap: 8px;\n	border-radius: 4px;\n	border: 1px solid rgba(0, 0, 0, 0.06);\n	background: #fff;\n	box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.04);\n\n	.title {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 18px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 31.2px */\n		letter-spacing: -0.72px;\n	}\n\n	.subTitle {\n		color: var(--desc-gray);\n		font-family: Pretendard;\n		font-size: 14px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n	}\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding: 24px 10px;\n	gap: 10px;\n	flex: 1 0 100%;\n	border-radius: 4px;\n	border: 1px solid rgba(0, 0, 0, 0.06);\n	width: 100%;\n	background: #fff;\n	box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.04);\n\n	picture {\n		display: flex;\n	}\n\n	.title {\n		color: var(--card-bg);\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 31.2px */\n		letter-spacing: -0.72px;\n	}\n\n	.subTitle {\n		color: var(--desc-gray);\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n	}\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 200px;\n	flex: 0;\n	flex-shrink: 0;\n	max-width: 600px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 24px 16px;\n	flex-direction: column;\n	align-items: flex-start;\n	gap: 16px;\n	flex: 1 0 100%;\n	border-radius: 4px;\n	border: 1px solid rgba(0, 0, 0, 0.06);\n	background: #fff;\n	box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.04);\n\n	.title {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 31.2px */\n		letter-spacing: -0.72px;\n		height: 50px;\n		width: 100%;\n	}\n\n	@media screen and (min-width: 600px) {\n		.title {\n			height: 60px;\n		}\n	}\n\n	.desc {\n		color: var(--desc-gray);\n		font-family: Pretendard;\n		font-size: 14px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 24px */\n		letter-spacing: -0.64px;\n		height: 100px;\n	}\n\n	.img {\n		height: 30px;\n		flex-shrink: 0;\n		margin-top: 10px;\n		margin-bottom: 10px;\n	}\n\n	.name {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 14px;\n		font-style: normal;\n		font-weight: 800;\n		line-height: 130%; /* 20.8px */\n		letter-spacing: -0.48px;\n	}\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 30px 2px 13px 2px;\n	flex-direction: column;\n	justify-content: flex-end;\n	align-items: center;\n	gap: 12px;\n	border-radius: 4px;\n	border: 1px solid rgba(0, 0, 0, 0.06);\n	background: #fff;\n	box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.04);\n\n	.profile-img {\n		width: 88px;\n		height: 88px;\n		border-radius: 50%;\n		object-fit: cover;\n	}\n\n	.name {\n		color: var(--card-bg);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 24px;\n		font-style: normal;\n		font-weight: 800;\n		line-height: 120%; /* 28.8px */\n		letter-spacing: -0.96px;\n	}\n\n	.desc {\n		color: var(--desc-gray);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 24px */\n		letter-spacing: -0.64px;\n	}\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	gap: 80px;\n\n	.ci-list .swiper-wrapper {\n		transition-timing-function: linear !important;\n		/* 추가: 모바일에서 드래그 시 끊김 방지 */\n		-webkit-transition-timing-function: linear !important;\n	}\n\n	.hidden {\n		opacity: 0;\n		pointer-events: none;\n	}\n\n	.floating {\n		display: flex;\n		flex-direction: column;\n		justify-content: center;\n		align-items: center;\n		gap: 10px;\n		position: fixed;\n		bottom: 50px;\n		left: 50%;\n		transform: translateX(-50%);\n		z-index: 1000;\n	}\n\n	.floating-btn-apply,\n	.floating-btn-consult {\n		display: flex;\n		flex-direction: row;\n		justify-content: center;\n		align-items: center;\n		font-size: 18px;\n		font-weight: bold;\n		padding: 10px 10px;\n		padding-right: 5px;\n		border-radius: 30px;\n		width: 230px;\n		cursor: pointer;\n		height: 60px;\n		box-shadow: 0 19px 38px rgba(0, 0, 0, 0.5);\n		transition: 0.3s ease;\n\n		&:hover {\n			transform: translateY(-4px);\n			box-shadow: 0 24px 48px rgba(0, 0, 0, 0.6);\n		}\n	}\n\n	.floating-btn-apply {\n		background-color: var(--primary);\n		color: white;\n	}\n\n	.floating-btn-consult {\n		background-color: white;\n		color: var(--primary);\n	}\n\n	@media screen and (max-width: 768px) {\n		.floating-btn-apply,\n		.floating-btn-consult {\n			width: 200px;\n			height: 50px;\n			border-radius: 50px;\n			font-size: 16px;\n		}\n	}\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	max-width: 768px;\n	padding: 0 10px;\n	position: relative;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	text-align: center;\n	font-size: 24px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 48px */\n	letter-spacing: -1.6px;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--primary);\n	font-size: 24px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 48px */\n	letter-spacing: -1.6px;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	font-size: 24px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 48px */\n	letter-spacing: -1.6px;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--desc-gray);\n	text-align: center;\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 130%; /* 30px */\n	letter-spacing: -0.8px;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	text-align: center;\n	font-size: 20px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 38.4px */\n	letter-spacing: -1.28px;\n\n	> span {\n		color: var(--primary);\n	}\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--primary);\n	text-align: left;\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 150%; /* 30px */\n	letter-spacing: -0.8px;\n	max-width: 816px;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	text-align: left;\n	width: 100%;\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 150%; /* 30px */\n	letter-spacing: -0.8px;\n	max-width: 816px;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	.swiper-pagination {\n		position: relative;\n		width: 100px !important;\n	}\n\n	.swiper-horizontal > .swiper-pagination-bullets,\n	.swiper-pagination-bullets.swiper-pagination-horizontal {\n		left: 50%;\n		transform: translateX(-50%);\n		bottom: -20px;\n		width: 300px !important;\n	}\n\n	.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,\n	.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {\n		background-color: var(--card-bg);\n	}\n	.profile-box {\n		width: 100%;\n		max-width: 1200px;\n		overflow: hidden;\n\n		.swiper {\n			padding-bottom: 50px;\n		}\n\n		.swiper-slide {\n			display: flex;\n			justify-content: center;\n			align-items: center;\n		}\n\n		.swiper-button-group {\n			position: absolute;\n			top: 50%;\n			transform: translateY(-50%);\n			width: 40px;\n			height: 40px;\n			padding-bottom: 100px;\n			cursor: pointer;\n\n			svg {\n				color: white;\n				font-size: 40px;\n			}\n		}\n\n		@media (max-width: 1200px) {\n			.swiper-button-group {\n				display: none;\n			}\n\n			.review-box {\n				padding-left: 0px;\n				padding-right: 0px;\n			}\n\n			div.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {\n				span.swiper-pagination-bullet-active {\n					background: white;\n				}\n				span.swiper-pagination-bullet {\n					width: 20px;\n				}\n			}\n		}\n\n		.swiper-button-prev-unique {\n			left: 0px;\n		}\n\n		.swiper-button-next-unique {\n			right: 0px;\n			z-index: 100;\n		}\n\n		.swiper-button-prev {\n			color: white;\n		}\n\n		.swiper-button-next {\n			color: white;\n		}\n\n		.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {\n			span.swiper-pagination-bullet-active {\n				background: white;\n			}\n			span.swiper-pagination-bullet {\n				width: 30px;\n				border-radius: 20px;\n			}\n		}\n	}\n\n	.profile-box {\n		.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {\n			span.swiper-pagination-bullet {\n				background: black;\n			}\n		}\n	}\n\n	.profile-item {\n		display: flex;\n		flex-direction: column;\n		/* width: 100%; */\n		border-radius: 4px;\n		position: relative;\n		/* background-color: white; */\n		border: 1px solid rgba(0, 0, 0, 0.06);\n		box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.04);\n\n		.top-box {\n			display: flex;\n			width: 100%;\n			flex-direction: column;\n			justify-content: start;\n			align-items: start;\n			position: relative;\n			border-top-right-radius: 40px;\n			border-top-left-radius: 40px;\n			z-index: 1;\n			padding: 0px 25px 0px 25px;\n			padding-top: 16px;\n\n			.name {\n				color: var(--card-bg);\n				font-family: Pretendard;\n				font-size: 24px;\n				font-style: normal;\n				font-weight: 800;\n				line-height: 120%; /* 28.8px */\n				letter-spacing: -0.96px;\n				padding-top: 16px;\n			}\n\n			.job {\n				color: var(--card-bg);\n				font-family: Pretendard;\n				font-size: 20px;\n				font-style: normal;\n				font-weight: 500;\n				line-height: 150%; /* 30px */\n				letter-spacing: -0.6px;\n			}\n\n			.profile-img {\n				width: 88px;\n				height: 88px;\n				border-radius: 100%;\n				overflow: hidden;\n				object-fit: cover;\n			}\n		}\n\n		.bottom-box {\n			display: flex;\n			flex-direction: column;\n			justify-content: start;\n			align-items: start;\n			position: relative;\n			flex-wrap: wrap;\n			background-color: white;\n			border-bottom-right-radius: 40px;\n			border-bottom-left-radius: 40px;\n			padding: 0px 0px 30px 25px;\n			gap: 12px;\n\n			.introduction {\n				color: var(--desc-gray);\n				font-size: 16px;\n				font-style: normal;\n				font-weight: 500;\n				line-height: 150%; /* 24px */\n				letter-spacing: -0.64px;\n			}\n\n			.tag-box,\n			.skill-box {\n				display: flex;\n				flex-direction: row;\n				justify-content: start;\n				align-items: start;\n				gap: 0px;\n				min-height: 40px;\n				flex-wrap: wrap;\n\n				.skill,\n				.tag {\n					display: flex;\n					padding: 0px 0px;\n					min-width: fit-content;\n					justify-content: center;\n					align-items: center;\n					gap: 10px;\n					color: var(--desc-gray);\n					text-align: center;\n					font-family: Pretendard;\n					font-size: 12px;\n					font-style: normal;\n					font-weight: 700;\n					line-height: 150%; /* 18px */\n					letter-spacing: -0.36px;\n					padding-right: 14px;\n				}\n			}\n\n			.go-profile {\n				display: flex;\n				flex-direction: row;\n				justify-content: start;\n				align-items: center;\n				cursor: pointer;\n\n				> div {\n					color: var(--primary);\n					font-family: Pretendard;\n					font-size: 16px;\n					font-style: normal;\n					font-weight: 800;\n					line-height: 130%; /* 20.8px */\n					letter-spacing: -0.64px;\n				}\n			}\n		}\n	}\n\n	@media (max-width: 1100px) and (min-width: 800px) {\n		.profile-item {\n			/* width: 304px;\n			height: 304px; */\n			* {\n				flex-wrap: wrap;\n			}\n\n			.top-box {\n				.name {\n				}\n\n				.job {\n				}\n\n				.profile-img {\n					top: 25px;\n					width: 80px;\n					height: 80px;\n				}\n			}\n			.bottom-box {\n				.introduction {\n					/* font-size: 12px; */\n				}\n			}\n		}\n	}\n\n	@media (max-width: 1280px) {\n		.profile-item {\n			/* width: 304px; */\n			/* height: 304px; */\n\n			.top-box {\n				.name {\n				}\n\n				.job {\n				}\n\n				.profile-img {\n					/* bottom: -30px;\n					width: 60px;\n					height: 60px; */\n				}\n			}\n			.bottom-box {\n				.introduction {\n					/* font-size: 12px; */\n				}\n			}\n		}\n	}\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 12px 102px 12px 16px;\n	align-items: center;\n	border-radius: 4px;\n	background: #edf0f5;\n	flex: 1 0 100%;\n	border: none;\n	color: var(--desc-gray);\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 130%; /* 20.8px */\n	letter-spacing: -0.64px;\n	width: 100%;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 12px 16px;\n	justify-content: center;\n	align-items: center;\n	gap: 10px;\n	border-radius: 4px;\n	background: var(--primary);\n	color: #fff;\n	text-align: center;\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 130%; /* 20.8px */\n	letter-spacing: -0.64px;\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	flex: 1;\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: inline-flex;\n	padding: 8px 12px;\n	justify-content: center;\n	align-items: center;\n	gap: 10px;\n	border-radius: 4px;\n	background: var(--primary);\n	color: #fff;\n	text-align: center;\n	font-size: 14px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 130%; /* 20.8px */\n	letter-spacing: -0.64px;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--card-bg);\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 150%; /* 30px */\n	letter-spacing: -0.8px;\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin-left: 0px;\n	padding-left: 20px;\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin-left: 0px;\n	padding-left: 20px;\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	color: var(--desc-gray);\n	font-size: 14px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 150%; /* 24px */\n	letter-spacing: -0.64px;\n	list-style: disc;\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	.swiper-pagination-bullet-active {\n		background-color: var(--card-bg) !important;\n	}\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	max-width: 1200px;\n\n	.swiper-pagination-bullet-active {\n		background-color: var(--card-bg) !important;\n	}\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	flex-shrink: 0;\n	border-radius: 16px;\n	overflow: hidden;\n	display: flex;\n	flex-direction: column;\n	justify-content: flex-end;\n	cursor: pointer;\n	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);\n\n	.img {\n		width: 100%;\n	}\n\n	.title {\n		color: var(--card-bg);\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 26px */\n		letter-spacing: -0.6px;\n	}\n\n	.card {\n		display: inline-flex;\n		padding: 4px 8px;\n		justify-content: center;\n		align-items: center;\n		gap: 10px;\n		border-radius: 4px;\n		background: var(--bg-white);\n		color: var(--desc-gray);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 10px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 150%; /* 18px */\n		letter-spacing: -0.36px;\n	}\n\n	@media screen and (min-width: 500px) {\n		width: calc(50% - 8px);\n\n		.title {\n			height: 60px;\n		}\n	}\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 440px;\n	height: 564px;\n	flex-shrink: 0;\n	border-radius: 4px;\n	border: 1px solid rgba(0, 0, 0, 0.06);\n	background: #fff;\n	flex-grow: 0;\n	flex-shrink: 0;\n	cursor: pointer;\n\n	.thumb {\n		width: 440px;\n		flex-shrink: 0;\n	}\n\n	.tag {\n		display: inline-flex;\n		padding: 4px 8px;\n		justify-content: center;\n		align-items: center;\n		gap: 10px;\n		border-radius: 4px;\n		background: var(--bg-white);\n		color: var(--desc-gray);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 12px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 150%; /* 18px */\n		letter-spacing: -0.36px;\n	}\n\n	.title {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 20.8px */\n		letter-spacing: -0.48px;\n	}\n\n	.name {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 12px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 18px */\n		letter-spacing: -0.48px;\n	}\n	.text {\n		color: var(--desc-gray);\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n	}\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	flex-shrink: 0;\n	border-radius: 4px;\n	border: 1px solid rgba(0, 0, 0, 0.06);\n	background: #fff;\n	cursor: pointer;\n\n	.thumb {\n		width: 100%;\n		flex-shrink: 0;\n	}\n\n	.tag {\n		display: inline-flex;\n		padding: 4px 8px;\n		justify-content: center;\n		align-items: center;\n		gap: 10px;\n		border-radius: 4px;\n		background: var(--bg-white);\n		color: var(--desc-gray);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 10px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 150%; /* 18px */\n		letter-spacing: -0.36px;\n	}\n\n	.title {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 130%; /* 20.8px */\n		letter-spacing: -0.48px;\n	}\n\n	.name {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 12px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 18px */\n		letter-spacing: -0.48px;\n	}\n\n	@media screen and (min-width: 500px) {\n		width: calc(50% - 8px);\n\n		.title {\n			height: 60px;\n		}\n	}\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	border: none;\n	background-color: white;\n	width: 100%;\n	padding: 0 10px;\n	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.06);\n\n	&.MuiAccordion-root {\n		max-width: 100vw !important;\n		&:before {\n			background-color: transparent !important;\n		}\n	}\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		transform: translateY(12px);\n		opacity: 0;\n	}\n	to {\n		transform: translateY(0);\n		opacity: 1;\n	}\n"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: inline-block;\n	animation: ",
        " 0.5s ease forwards;\n	vertical-align: bottom;\n	position: relative;\n	top: -0.5px;\n	margin: 0 1px 0 3px;\n"
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
























var MainContentsMobile = function() {
    var user = (0,_src_hook_useUser__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().user;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_11__.useRouter)();
    var setDefaultMessage = (0,recoil__WEBPACK_IMPORTED_MODULE_14__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_10__/* .defaultMessageAtom */ .Em);
    var setSnackbareState = (0,recoil__WEBPACK_IMPORTED_MODULE_14__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_10__/* .globalSnackbarState */ .j8);
    var setIsApplyOpen = (0,recoil__WEBPACK_IMPORTED_MODULE_14__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_10__/* .isApplyOpenAtom */ .Vu);
    var setIsChatOpen = (0,recoil__WEBPACK_IMPORTED_MODULE_14__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_10__/* .isChatOpenAtom */ .P2);
    var userInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_14__/* .useRecoilValue */ .sJ)(_src_state__WEBPACK_IMPORTED_MODULE_10__/* .userInfoAtom */ .wl);
    (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function() {
        var scrollFunction = function() {
            var ref;
            if (scrollY > ((ref = document.querySelector("#client-apply-mid")) === null || ref === void 0 ? void 0 : ref.offsetHeight)) {
                var ref1;
                (ref1 = document.querySelector(".floating")) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("hidden");
            } else {
                var ref2;
                (ref2 = document.querySelector(".floating")) === null || ref2 === void 0 ? void 0 : ref2.classList.add("hidden");
            }
        };
        window.addEventListener("scroll", scrollFunction);
        return function() {
            window === null || window === void 0 ? void 0 : window.removeEventListener("scroll", scrollFunction);
        };
    }, []);
    var 플로팅버튼 = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "floating column-center-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                onClick: function() {
                    if (user.isLogin && user.userType === 2) {
                        setSnackbareState("고객사 전용 서비스입니다.\n문의사항은 우측 하단 채널톡을 이용해주시기 바랍니다.");
                        return;
                    }
                    var tagManagerArgs = {
                        dataLayer: {
                            event: "client-apply-start"
                        }
                    };
                    if (!window.localStorage.getItem("accessToken")) {
                        react_gtm_module__WEBPACK_IMPORTED_MODULE_13___default().dataLayer(tagManagerArgs);
                    }
                    setDefaultMessage("");
                    if (user.isLogin) {
                        setIsChatOpen(true);
                    } else {
                        setIsApplyOpen(true);
                    }
                },
                className: "floating-btn-apply apply-button",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    children: "지금 바로 상담 받기"
                })
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .Global */ .xB, {
                styles: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .css */ .iv)(_templateObject())
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainContentsContainer, {
                className: "column-center-start",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MainCtaContents, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CIList, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WhenWeNeed, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HowToVerify, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ExpertList, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GetProfileNewsLetter, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Purpose, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Process, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BestPractice, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ReviewList, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlogSection, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FAQSection, {}),
                    플로팅버튼()
                ]
            })
        ]
    });
};
var rollingNumbers = [
    "5",
    "10",
    "20"
];
var MainCtaContents = function() {
    var user = (0,_src_hook_useUser__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().user;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_11__.useRouter)();
    var setIsApplyOpen = (0,recoil__WEBPACK_IMPORTED_MODULE_14__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_10__/* .isApplyOpenAtom */ .Vu);
    var setIsChatOpen = (0,recoil__WEBPACK_IMPORTED_MODULE_14__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_10__/* .isChatOpenAtom */ .P2);
    var userInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_14__/* .useRecoilValue */ .sJ)(_src_state__WEBPACK_IMPORTED_MODULE_10__/* .userInfoAtom */ .wl);
    var setDefaultMessage = (0,recoil__WEBPACK_IMPORTED_MODULE_14__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_10__/* .defaultMessageAtom */ .Em);
    var setSnackbareState = (0,recoil__WEBPACK_IMPORTED_MODULE_14__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_10__/* .globalSnackbarState */ .j8);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(0), numIndex = ref[0], setNumIndex = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function() {
        var interval = setInterval(function() {
            setNumIndex(function(prev) {
                return (prev + 1) % rollingNumbers.length;
            });
        }, 2500);
        return function() {
            return clearInterval(interval);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MainCtaContentsContainer, {
        className: "column-center-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ContentsContainer, {
            className: "column-center-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MatinCtaContentsInner, {
                className: "column-center-start",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h1", {
                        className: "cta-title-box",
                        style: {
                            margin: "0 auto"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "row-center-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                    children: [
                                        "상위 ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: "blue",
                                            children: "10%"
                                        }),
                                        " 마케터를"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        children: "주"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MobileRollingTextSpan, {
                                        className: "blue",
                                        children: rollingNumbers[numIndex]
                                    }, numIndex),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        children: "시간 고용하세요"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__/* .EmptySpace */ .zV, {
                        space: 20
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MainCtaButton, {
                        variant: "contained",
                        id: "client-apply-mid",
                        className: "apply-button",
                        onClick: function() {
                            if (user.isLogin && user.userType === 2) {
                                setSnackbareState("고객사 전용 서비스입니다.\n문의사항은 우측 하단 채널톡을 이용해주시기 바랍니다.");
                                return;
                            }
                            var tagManagerArgs = {
                                dataLayer: {
                                    event: "client-apply-start"
                                }
                            };
                            if (!window.localStorage.getItem("accessToken")) {
                                react_gtm_module__WEBPACK_IMPORTED_MODULE_13___default().dataLayer(tagManagerArgs);
                            }
                            setDefaultMessage("");
                            if (user.isLogin) {
                                setIsChatOpen(true);
                            } else {
                                setIsApplyOpen(true);
                            }
                        },
                        children: "지금 바로 상담 받기"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        onClick: function() {
                            setDefaultMessage("안녕하세요! 원포인트 AI 마케팅 상담봇입니다 \uD83D\uDE42\n\n회사나 브랜드, 혹은 현재 상황이나 고민하고 계신 부분에 대해 편하게 말씀해주시면 차근차근 도와드릴게요!");
                            if (user.isLogin && user.userType === 2) {
                                setSnackbareState("고객사 전용 서비스입니다.\n문의사항은 우측 하단 채널톡을 이용해주시기 바랍니다.");
                                return;
                            }
                            if (user.isLogin) {
                                setIsChatOpen(true);
                            } else {
                                setIsApplyOpen(true);
                            }
                        },
                        className: "ai-consult-button",
                        style: {
                            color: "#666666",
                            textDecoration: "none",
                            cursor: "pointer",
                            fontSize: "12px",
                            marginTop: "12px",
                            transition: "all 0.2s ease",
                            borderBottom: "1px solid transparent",
                            paddingBottom: "2px",
                            letterSpacing: "-0.3px"
                        },
                        onTouchStart: function(e) {
                            e.currentTarget.style.color = "var(--primary)";
                            e.currentTarget.style.borderBottom = "1px solid var(--primary)";
                        },
                        onTouchEnd: function(e) {
                            e.currentTarget.style.color = "#666666";
                            e.currentTarget.style.borderBottom = "1px solid transparent";
                        },
                        children: "5분 안에 마케팅 진단 먼저 받아보기"
                    })
                ]
            })
        })
    });
};
var WhenWeNeed = function() {
    var a = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ContentsContainer, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                order: "column-start-center",
                gap: 20,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionTitle, {
                    children: "검증된 탑티어 프리랜서 마케터,\n언제 필요할까요?"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__/* .EmptySpace */ .zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .PaperA */ .iV, {
                fullWidth: true,
                variant: "transparent",
                order: "column-start-between",
                gap: 8,
                px: 0,
                py: 0,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WhyCard, {
                        imgSrc: WhyCardList[0].imgSrc,
                        title: WhyCardList[0].title,
                        subTitle: WhyCardList[0].subTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WhyCard, {
                        imgSrc: WhyCardList[1].imgSrc,
                        title: WhyCardList[1].title,
                        subTitle: WhyCardList[1].subTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WhyCard, {
                        imgSrc: WhyCardList[2].imgSrc,
                        title: WhyCardList[2].title,
                        subTitle: WhyCardList[2].subTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WhyCard, {
                        imgSrc: WhyCardList[3].imgSrc,
                        title: WhyCardList[3].title,
                        subTitle: WhyCardList[3].subTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__/* .EmptySpace */ .zV, {
                space: 8
            })
        ]
    });
};
var HowToVerify = function() {
    var ref = (0,_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .useModal */ .dd)(), openModal = ref.openModal, isOpen = ref.isOpen, closeModal = ref.closeModal;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_11__.useRouter)();
    var isTablet = (0,_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("(min-width: 620px)");
    (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function() {
        if (router.query["expert-evaluation-example"] === "true") {
            openModal();
        }
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ContentsContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ContentsContainer, {
                className: "column-center-start how-to-verify",
                style: {
                    background: "var(--bg-white)",
                    padding: 0
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .Empty */ .HY, {
                        space: 95
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionTitle, {
                        children: "3단계 검증 시스템으로"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(HowToVerrifyBigTitle, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                className: "blue",
                                children: "상위 10% 마케터"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: "를 선발합니다"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .Empty */ .HY, {
                        space: 60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "column-start-start",
                        style: {
                            gap: 40,
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "row-start-start",
                                style: {
                                    paddingLeft: "24px",
                                    gap: 16,
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PentagonContainer, {
                                    className: "row-center-between",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                                        order: "column-start-start",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HowToVerifyStepTitle, {
                                                children: "1단계"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionSmallTitle, {
                                                children: "서류 평가"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .Empty */ .HY, {
                                                space: 0
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HowAnswerDiv, {
                                                children: "이력, 프로젝트 경험, 포트폴리오를 기반으로\n경력과 성과를 확인합니다"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .Empty */ .HY, {
                                                space: 0
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HowToAnswerDiv, {
                                                children: "지원자의 70%만 합격합니다"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "row-start-start",
                                style: {
                                    paddingLeft: "24px",
                                    gap: 16,
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PentagonContainer, {
                                    className: "row-center-between",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                                        order: "column-start-start",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HowToVerifyStepTitle, {
                                                children: "2단계"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionSmallTitle, {
                                                children: "역량 평가"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .Empty */ .HY, {
                                                space: 0
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HowAnswerDiv, {
                                                children: "논술형 평가를 통해 직무별\n문제 해결 역량과 스킬을 파악합니다"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .Empty */ .HY, {
                                                space: 0
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HowToAnswerDiv, {
                                                children: "지원자의 30%만 합격합니다"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "row-start-start",
                                style: {
                                    paddingLeft: "24px",
                                    gap: 16,
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PentagonContainer, {
                                    className: "row-center-between",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                                        order: "column-start-start",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HowToVerifyStepTitle, {
                                                children: "3단계"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionSmallTitle, {
                                                children: "심층 면접"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .Empty */ .HY, {
                                                space: 0
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HowAnswerDiv, {
                                                children: "커뮤니케이션 역량 및 적극성 등\n소프트 스킬을 검증합니다"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .Empty */ .HY, {
                                                space: 0
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HowToAnswerDiv, {
                                                children: "지원자의 10%만 합격합니다"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .Empty */ .HY, {
                        space: 80
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlogCtaButton, {
                        variant: "contained",
                        onClick: openModal,
                        children: "실제 역량 평가 사례가 궁금하다면?"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__/* .EmptySpace */ .zV, {
                        space: 40
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .ModalA */ .zk, {
                zIndex: 10001,
                maxWidth: "800px",
                bgColor: "white",
                isOpen: isOpen,
                onClose: closeModal,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .PaperA */ .iV, {
                    variant: "transparent",
                    order: "column-center-center",
                    gap: 16,
                    px: 16,
                    py: 0,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionSmallTitle, {
                            children: "실제 역량 평가 문제 & 답변"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .PaperA */ .iV, {
                            variant: "transparent",
                            order: "column-center-center",
                            gap: 16,
                            px: 0,
                            py: 0,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionSmallSubTitle, {
                                    children: "당신은 글로벌 가전 브랜드 Dyson의 디지털 마케팅팀에서 최근 출시한 프리미엄 공기청정기 라인의 온라인 광고 캠페인을 담당하고 있습니다. 지난 분기 동안 이 제품 라인의 자사 온라인 스토어 판매가 예상보다 저조했으며, 특히 주요 타겟 그룹에서의 구매 전환율이 낮은 것으로 나타났습니다. 초기 분석 결과, 주요 원인으로는 다음 두 가지가 지목되었습니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionSmallSubTitle2, {
                                    children: [
                                        "1. 경쟁 브랜드들의 공격적인 마케팅으로 인한 시장 점유율 감소 ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                        "2. 소비자들의 높은 가격 민감도와 경기 불황으로 인한 구매 의사 결정 지연"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionSmallSubTitle, {
                                    children: "온라인 광고 성과는 전반적으로 기대에 미치지 못하고 있으며, 특히 광고 클릭에서 실제 구매로 이어지는 전환율이 낮은 상황입니다. 현재 상황을 어떻게 분석하고 온라인 광고에서의 전환율 향상을 위해 어떤 전략과 액션을 수행할지 서술하세요."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__/* .EmptySpace */ .zV, {
                            space: 20
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            style: {
                                maxWidth: "100%"
                            },
                            src: "/onepoint/images/renewal/how-section/example-mobile.png",
                            alt: ""
                        })
                    ]
                })
            })
        ]
    });
};
var PentagonSubTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject1());
var PentagonTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject2());
var PentagonTitle2 = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject3());
var PentagonContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject4());
var Pentagon = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject5(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor || "#1C1F2E";
}, function(param) {
    var width = param.width;
    return width || "200px";
}, function(param) {
    var height = param.height;
    return height || "168px";
}, function(param) {
    var angle = param.angle;
    return angle ? angle + "%" : "80%";
});
var HowToVerifyStepTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject6());
var HowToVerrifyBigTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject7());
var TestExample = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject8());
var ExpertList = function() {
    var a = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SwiperSectionContents, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .PaperA */ .iV, {
                variant: "transparent",
                order: "row-center-center",
                gap: 20,
                px: 16,
                py: 0,
                fullWidth: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionTitle, {
                    children: "원포인트 자체 검증 시스템을 거친\n탑티어 전문가를 만나보세요"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .Empty */ .HY, {
                space: 20
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
                className: "profile-box",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_16__/* .Swiper */ .tq, {
                    navigation: {
                        nextEl: ".swiper-button-next-unique",
                        prevEl: ".swiper-button-prev-unique"
                    },
                    modules: [
                        swiper_modules__WEBPACK_IMPORTED_MODULE_15__/* .Pagination */ .tl,
                        swiper_modules__WEBPACK_IMPORTED_MODULE_15__/* .Navigation */ .W_,
                        swiper_modules__WEBPACK_IMPORTED_MODULE_15__/* .Scrollbar */ .LW,
                        swiper_modules__WEBPACK_IMPORTED_MODULE_15__/* .Autoplay */ .pt
                    ],
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    loop: true,
                    spaceBetween: 20,
                    pagination: {
                        enabled: true
                    },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                        pauseOnMouseEnter: true
                    },
                    children: profileDataArray.map(function(v, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_16__/* .SwiperSlide */ .o5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "profile-item",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "top-box",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                className: "profile-img",
                                                src: v.imageUrl,
                                                alt: "".concat(v.name, " 프로필이미지")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "name",
                                                children: v.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "job",
                                                children: v.job
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                                                order: "row-center-start",
                                                gap: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        src: "/onepoint/images/renewal/expert-section/verify.png",
                                                        alt: "",
                                                        style: {
                                                            width: "16px",
                                                            height: "16px"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        style: {
                                                            fontSize: "12px",
                                                            color: "var(--primary)"
                                                        },
                                                        children: "검증된 전문가"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__/* .EmptySpace */ .zV, {
                                                space: 8
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "bottom-box",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "introduction",
                                                children: v.introduction
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "skill-box",
                                                children: [
                                                    v.tagList,
                                                    v.skillList
                                                ].flat().map(function(skill, i) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "skill",
                                                        children: skill
                                                    }, "profile-skill-".concat(i));
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "go-profile",
                                                onClick: function() {
                                                    window.open(v.profileUrl, "_blank");
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    children: "프로필 보기 "
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, "profileData-".concat(i));
                    })
                })
            })
        ]
    });
};
var GetProfileNewsLetter = function() {
    var a = 1;
    var setSnackbareState = (0,recoil__WEBPACK_IMPORTED_MODULE_14__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_10__/* .globalSnackbarState */ .j8);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_12__.useState(""), 2), email = ref[0], setEmail = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_12__.useState(false), 2), isLoad = ref1[0], setIsLoad = ref1[1];
    var handleOnClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(function() {
            var _tmp, error, _tmp1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(0,_src_utils_sign__WEBPACK_IMPORTED_MODULE_22__/* .validateEmail */ .oH)(email)) return [
                            3,
                            7
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            5,
                            6
                        ]);
                        setIsLoad(true);
                        _tmp = {};
                        return [
                            4,
                            (0,_src_api_sign__WEBPACK_IMPORTED_MODULE_4__/* .subscribeStibee */ .ot)((_tmp.email = email, _tmp.type = "프로필", _tmp.ads = "O", _tmp))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        error = _state.sent();
                        _tmp1 = {};
                        return [
                            4,
                            (0,_src_api_error__WEBPACK_IMPORTED_MODULE_3__/* .sendSlackError */ .N)((_tmp1.message = "구독하기 실패" + email, _tmp1.title = "구독 프론트엔드 에러", _tmp1.channel = "error", _tmp1))
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setIsLoad(false);
                        return [
                            7
                        ];
                    case 6:
                        setSnackbareState("구독이 완료되었습니다.");
                        setEmail("");
                        return [
                            3,
                            8
                        ];
                    case 7:
                        setSnackbareState("이메일 형식이 맞지 않습니다.");
                        _state.label = 8;
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ContentsContainer, {
        className: "row-center-center",
        style: {
            background: "var(--bg-white)",
            borderRadius: "20px",
            padding: "60px 40px",
            gap: "20px",
            boxShadow: "0px 4px 24px 0px rgba(0, 0, 0, 0.07)"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionTitle, {
                children: "탑티어 전문가의\n프로필을 받아보세요"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                order: "column-center-start",
                gap: 4,
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                        order: "row-center-center",
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubscribeInput, {
                                value: email,
                                onChange: function(e) {
                                    return setEmail(e.target.value);
                                },
                                placeholder: "work@email.com"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubscribeButton, {
                                variant: "contained",
                                loading: isLoad,
                                id: "subscribe_profile",
                                onClick: handleOnClick,
                                sx: {
                                    flex: 1,
                                    minWidth: "85px"
                                },
                                children: "구독하기"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                        style: {
                            color: "var(--desc-gray)",
                            fontSize: "14px",
                            marginTop: "5px",
                            textAlign: "right",
                            letterSpacing: "-0.64px"
                        },
                        children: [
                            "구독시",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomA, {
                                style: {
                                    color: "var(--desc-gray)",
                                    letterSpacing: "-0.64px"
                                },
                                target: "_blank",
                                href: "https://notion.1point.kr/privacy",
                                rel: "noreferrer",
                                children: "개인정보 수집 및 이용"
                            }),
                            "에 동의하게 됩니다"
                        ]
                    })
                ]
            })
        ]
    });
};
var CustomA = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].a */ .Z.a(_templateObject9());
var list = [
    {
        title: "퍼포먼스 마케터",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "목적에 맞는 디지털 광고 구성과 광고비 성과 최적화가 필요할 때",
                "광고비를 사용해 콘텐츠 마케팅 대비 빠른 유입/전환을 만들어야 할 때",
                "소비자 타겟 및 데이터를 광고를 통해 파악해야 할 때", 
            ],
            exList: [
                "퍼포먼스 마케팅 매체 전략 수립",
                "미디어 믹스 전략 기획",
                "소재 A/B 테스트",
                "소재 셋팅과 성과 최적화",
                "성과 분석 및 리포팅",
                "대행사 활용 시 대행사 핸들링",
                "메타/구글/네이버 키워드 등 필요 매체 운영", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog/best-practices/mj-groupby/"
            }
        }
    },
    {
        title: "브랜드 마케터",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "전반적인 브랜드 전략 수립이 필요할 때",
                "BI를 소비자에게 인식시키기 위한 장기 전략이 필요할 때",
                "소비자에게 사랑받는 브랜드 아이덴티티(BI) 구축이 필요할 때", 
            ],
            exList: [
                "브랜드 전략 수립 (컨셉/브랜드 네이밍 개발)",
                "브랜드 포지셔닝 전략 수립",
                "브랜드 컨셉 및 핵심가치 등 전략 수립",
                "브랜드 마케팅 캠페인 실행안 기획",
                "브랜드 광고 마케팅 전략 수립",
                "브랜드 마케팅 대행사 활용 시 대행사 핸들링", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog/best-practices/philip-startupcode/"
            }
        }
    },
    {
        title: "콘텐츠 마케터",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "타겟에게 적합하고 신선한 크리에이티브 기획이 필요할 때",
                "일관적인 브랜드 이미지 구축과 커뮤니케이션을 위한 콘텐츠 기획이 필요할 때",
                "SNS 초기 셋팅 시 콘텐츠의 톤앤매너와 방향성 수립이 필요할 때", 
            ],
            exList: [
                "콘텐츠 마케팅 방향성/매체 전략 수립",
                "콘텐츠 전략과 톤앤매너 전략 수립",
                "이미지/영상 콘텐츠 기획",
                "콘텐츠 발행 및 성과 분석",
                "상세 페이지 기획/개선/가이드/카피라이팅",
                "광고 소재 기획/카피라이팅", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog/best-practices/paradot/"
            }
        }
    },
    {
        title: "블로그/뉴스레터 마케터",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "장기적으로 블로그 콘텐츠를 발행해 소비자의 신뢰도를 올려야 할 때",
                "소비자가 많은 정보를 찾아보는 고관여 제품, B2B 제품 판매 시 특히 적합",
                "유저와의 커뮤니케이션으로 광고비 없이 오가닉 유입을 이끌어야 할 때", 
            ],
            exList: [
                "블로그 콘텐츠 전략과 톤앤매너 전략 수립",
                "블로그/뉴스레터 콘텐츠 기획 & 작성",
                "블로그/뉴스레터 발행 및 성과 분석", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog/best-practices/nry-boundx/"
            }
        }
    },
    {
        title: "이커머스 마케터",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "자사몰 제품 판매를 위한 마케팅 전략이 필요할 때",
                "광고 클릭율은 높은데 전환이 떨어질 때",
                "자사몰 및 상세 페이지 전반에 대한 개선과 가이드가 필요할 때", 
            ],
            exList: [
                "자사몰 전환 최적화를 위한 액션 제안과 실행",
                "제품 상세 페이지 개선 기획",
                "전환율 최적화 전략 수립",
                "이커머스 광고 캠페인 기획 및 실행",
                "성과 분석 및 리포팅",
                "대행사 활용 시 대행사 핸들링", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog/best-practices/purposed-dreve/"
            }
        }
    },
    {
        title: "CRM 마케터",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "초기 CRM 전략 및 툴 셋팅이 필요할 때",
                "고객 세그먼트를 체계적으로 관리하고 싶을 때",
                "고객 세그먼트에 맞춰 재구매와 추가 구매를 유도해야 할 때", 
            ],
            exList: [
                "CRM 툴 셋팅과 캠페인 기획&운영",
                "고객 데이터 분석",
                "고객 세그먼트화",
                "데이터를 통한 고객 만족도 조사 및 개선",
                "채널톡/이메일 캠페인 기획 및 운영", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog/"
            }
        }
    },
    {
        title: "SEO/SEM 마케터",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "검색 엔진에서 회사와 제품 상위 노출이 필요할 때",
                "검색을 통한 오가닉 유입 전략을 세우고 싶을 때", 
            ],
            exList: [
                "SEO/SEM 현황 점검/전략 도출",
                "검색 엔진 최적화 전략 수립",
                "구글 애널리틱스 분석",
                "키워드 연구 및 분석", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog/"
            }
        }
    },
    {
        title: "디자이너",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "고객에게 신뢰를 주는 일관된 브랜드 아이덴티티(BI/CI) 구축이 필요할 때",
                "사용자 경험(UX/UI)을 개선하여 웹/앱 서비스의 이탈률을 낮추고 싶을 때",
                "마케팅 메시지를 효과적으로 전달하는 상세페이지, 광고 소재 등이 필요할 때", 
            ],
            exList: [
                "브랜드 아이덴티티(로고, 컬러, 서체) 시스템 구축",
                "웹/앱 서비스의 UX/UI 설계 및 디자인",
                "상세페이지, 이벤트 페이지 등 마케팅 콘텐츠 디자인",
                "SNS 채널(인스타그램, 페이스북) 콘텐츠 디자인",
                "브로슈어, 명함 등 인쇄물 디자인",
                "전체적인 디자인 톤앤매너 수립 및 가이드라인 제작", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog"
            }
        }
    },
    {
        title: "영상 소재 제작 전문가",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "제품/서비스를 매력적으로 보여줄 광고 영상이 필요할 때",
                "시선을 사로잡는 숏폼(릴스, 쇼츠) 콘텐츠를 만들고 싶을 때",
                "브랜드 스토리 등 전문적인 영상이 필요할 때",
                "콘텐츠는 있지만, 영상으로 만드는 데 어려움을 겪을 때", 
            ],
            exList: [
                "영상 소재 기획, 제작 및 편집",
                "플랫폼별 영상 최적화", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog"
            }
        }
    }, 
];
var Purpose = function() {
    //
    var a = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ContentsContainer, {
        className: "row-center-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionTitle, {
                children: "목적에 맞는 전문가를 매칭 받으세요"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__/* .EmptySpace */ .zV, {
                space: 42
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionRight, {
                children: list.map(function(faq, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CustomAccordion, {
                        defaultExpanded: i === 0,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_AccordionSummary__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                    htmlColor: "black"
                                }),
                                sx: {
                                    color: "var(--card-bg)",
                                    paddingLeft: "24px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionSmallTitle, {
                                    children: faq.title
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_AccordionDetails__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                sx: {
                                    color: "black",
                                    whiteSpace: "pre-wrap",
                                    background: "white",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "start",
                                    gap: "20px",
                                    paddingBottom: "20px",
                                    paddingLeft: "24px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                                        order: "column-start-start",
                                        gap: 8,
                                        fullWidth: true,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                                                order: "column-start-start",
                                                gap: 8,
                                                fullWidth: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FAQAnswerTitle, {
                                                    children: faq.a.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                                                order: "row-start-between",
                                                gap: 0,
                                                fullWidth: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AnswerListUl, {
                                                    children: faq.a.list.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FAQAnswerList, {
                                                            children: item
                                                        }, "faq-answer-".concat(index));
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__/* .EmptySpace */ .zV, {
                                                space: 12
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                                                order: "column-start-start",
                                                gap: 8,
                                                fullWidth: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FAQAnswerTitle, {
                                                    children: "어떤 업무를 요청하나요?"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                                                order: "row-start-between",
                                                gap: 0,
                                                fullWidth: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AnswerListUl, {
                                                    children: faq.a.exList.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FAQAnswerList, {
                                                            children: item
                                                        }, "faq-answer-ex-".concat(index));
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FAQButton, {
                                        variant: "contained",
                                        onClick: function() {
                                            window.open(faq.a.button.url);
                                        },
                                        children: faq.a.button.text
                                    })
                                ]
                            })
                        ]
                    }, "accordion".concat(i));
                })
            })
        ]
    });
};
var Process = function() {
    var a = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ContentsContainer, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                order: "column-start-center",
                gap: 20,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionTitle, {
                    children: "상담에서 계약까지 7일\n빠른 업무 투입이 가능합니다"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__/* .EmptySpace */ .zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                order: "column-start-between",
                gap: 16,
                fullWidth: true,
                children: ProcessCardList.map(function(item, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WhyCard, {
                        imgSrc: item.imgSrc,
                        title: item.title,
                        subTitle: item.subTitle
                    }, "ProcessCard" + index);
                })
            })
        ]
    });
};
var CIList = function() {
    // 로고 데이터 배열 - ci-images 폴더의 모든 파일들
    var allLogoData = [
        "/onepoint/images/renewal/ci-images/youhan.png",
        "/onepoint/images/renewal/ci-images/scatter.png",
        "/onepoint/images/renewal/ci-images/r2w.png",
        "/onepoint/images/renewal/ci-images/lgelec.png",
        "/onepoint/images/renewal/ci-images/levit.png",
        "/onepoint/images/renewal/ci-images/kearney.png",
        "/onepoint/images/renewal/ci-images/jandi.png",
        "/onepoint/images/renewal/ci-images/fursys.png",
        "/onepoint/images/renewal/ci-images/frendliai.png",
        "/onepoint/images/renewal/ci-images/freedom.png",
        "/onepoint/images/renewal/ci-images/esther.png",
        "/onepoint/images/renewal/ci-images/dotus.png",
        "/onepoint/images/renewal/ci-images/salady.png",
        "/onepoint/images/renewal/ci-images/celimax.png",
        "/onepoint/images/renewal/ci-images/heum.png",
        "/onepoint/images/renewal/ci-images/rsquare.png",
        "/onepoint/images/renewal/ci-images/apartmentary.png",
        "/onepoint/images/renewal/ci-images/mckinsey.png",
        "/onepoint/images/renewal/ci-images/lguplus.png",
        "/onepoint/images/renewal/ci-images/hanwha.png", 
    ];
    // 첫 번째 줄용 로고 (앞쪽 10개)
    var firstRowLogos = allLogoData.slice(0, 10);
    // 두 번째 줄용 로고 (뒤쪽 10개)
    var secondRowLogos = allLogoData.slice(10, 20);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "ci-list",
        style: {
            width: "100vw",
            marginLeft: "calc(-50vw + 50%)",
            background: "white"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                style: {
                    maxWidth: "768px",
                    margin: "0 auto",
                    padding: "0 10px"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionTitle, {
                        children: "성장하는 기업은 원포인트를 이용합니다"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__/* .EmptySpace */ .zV, {
                        space: 40
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                style: {
                    width: "100vw",
                    overflow: "hidden",
                    padding: "0 10px"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        style: {
                            marginBottom: "20px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_16__/* .Swiper */ .tq, {
                            modules: [
                                swiper_modules__WEBPACK_IMPORTED_MODULE_15__/* .Autoplay */ .pt
                            ],
                            slidesPerView: "auto",
                            spaceBetween: 0,
                            loop: true,
                            freeMode: true,
                            autoplay: {
                                delay: 0,
                                disableOnInteraction: false
                            },
                            speed: 4000,
                            style: {
                                width: "100%",
                                transitionTimingFunction: "linear"
                            },
                            children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(firstRowLogos).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(firstRowLogos), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(firstRowLogos)).map(function(logo, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_16__/* .SwiperSlide */ .o5, {
                                    style: {
                                        width: "140px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        style: {
                                            height: "50px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            transition: "all 0.3s ease"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            src: logo,
                                            alt: "company-".concat(index + 1),
                                            style: {
                                                objectFit: "contain",
                                                height: "50px"
                                            }
                                        })
                                    })
                                }, "logo-1-".concat(index));
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_16__/* .Swiper */ .tq, {
                            modules: [
                                swiper_modules__WEBPACK_IMPORTED_MODULE_15__/* .Autoplay */ .pt
                            ],
                            slidesPerView: "auto",
                            spaceBetween: 0,
                            loop: true,
                            freeMode: true,
                            dir: "rtl",
                            autoplay: {
                                delay: 0,
                                disableOnInteraction: false
                            },
                            speed: 4000,
                            style: {
                                width: "100%",
                                transitionTimingFunction: "linear"
                            },
                            children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(secondRowLogos).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(secondRowLogos), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(secondRowLogos)).slice().reverse().map(function(logo, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_16__/* .SwiperSlide */ .o5, {
                                    style: {
                                        width: "140px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        style: {
                                            height: "50px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            transition: "all 0.3s linear"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            src: logo,
                                            alt: "company-".concat(index + 1),
                                            style: {
                                                objectFit: "contain",
                                                height: "50px"
                                            }
                                        })
                                    })
                                }, "logo-2-".concat(index));
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var ReviewList = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ContentsContainer, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ReviewContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_16__/* .Swiper */ .tq, {
                    modules: [
                        swiper_modules__WEBPACK_IMPORTED_MODULE_15__/* .Pagination */ .tl,
                        swiper_modules__WEBPACK_IMPORTED_MODULE_15__/* .Scrollbar */ .LW,
                        swiper_modules__WEBPACK_IMPORTED_MODULE_15__/* .Autoplay */ .pt
                    ],
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    loop: true,
                    spaceBetween: 20,
                    pagination: {
                        clickable: true,
                        el: ".c-list-pagination2"
                    },
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: true,
                        pauseOnMouseEnter: true
                    },
                    breakpoints: {
                        600: {
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                            spaceBetween: 20,
                            centeredSlides: false,
                            autoplay: {
                                delay: 5000,
                                disableOnInteraction: true,
                                pauseOnMouseEnter: true
                            }
                        }
                    },
                    children: ReviewData.map(function(v, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_16__/* .SwiperSlide */ .o5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ReviewCard, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                                    order: "column-center-start",
                                    gap: 12,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                                            order: "column-center-start",
                                            gap: 8,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "title",
                                                    children: v.title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "desc",
                                                    children: v.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                                            order: "column-start-start",
                                            gap: 8,
                                            fullWidth: true,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    className: "img",
                                                    src: v.img,
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "name",
                                                    children: [
                                                        v.company,
                                                        " ",
                                                        v.name ? "| ".concat(v.name, " ").concat(v.position) : ""
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, "review-".concat(i));
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__/* .EmptySpace */ .zV, {
                space: 24
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CListPagination, {
                className: "c-list-pagination2 row-center-center"
            })
        ]
    });
};
var BestPractice = function() {
    //
    var a = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ContentsContainer, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionTitle, {
                children: "원포인트 고객사의\n실제 성공 사례입니다"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .Empty */ .HY, {
                space: 40
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                order: "row-center-center",
                gap: 8,
                bgColor: "",
                style: {
                    rowGap: "16px",
                    flexWrap: "wrap"
                },
                children: BpList.map(function(v, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BpCard, {
                        onClick: function() {
                            window.open(v.url);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            style: {
                                height: "100%",
                                width: "100%"
                            },
                            className: "column-start-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    className: "img",
                                    src: v.imgSrc,
                                    alt: "bp_ap.png"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .PaperA */ .iV, {
                                    variant: "transparent",
                                    px: 20,
                                    py: 20,
                                    order: "column-start-start",
                                    gap: 8,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "title",
                                            children: v.title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "card",
                                            children: v.name
                                        })
                                    ]
                                })
                            ]
                        })
                    }, "bp-card-".concat(i));
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__/* .EmptySpace */ .zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlogCtaButton, {
                variant: "contained",
                onClick: function() {
                    window.open("https://1point.kr/blog/best-practices/");
                },
                children: "더 보러가기"
            })
        ]
    });
};
var BlogSection = function() {
    //
    var a = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ContentsContainer, {
        className: "column-center-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionTitle, {
                children: "검증된 전문가의\n인사이트를 만나보세요"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .Empty */ .HY, {
                space: 40
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                order: "row-center-center",
                gap: 8,
                children: InsightList.map(function(v, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(InsightCard, {
                        onClick: function() {
                            window.open(v.url);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: "thumb",
                                src: v.imgSrc
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .PaperA */ .iV, {
                                variant: "transparent",
                                px: 16,
                                py: 16,
                                order: "column-start-start",
                                gap: 4,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                                        order: "column-start-start",
                                        gap: 8,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "title",
                                            children: v.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "name",
                                        children: [
                                            "by ",
                                            v.name
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, "insight-card-".concat(i));
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__/* .EmptySpace */ .zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlogCtaButton, {
                variant: "contained",
                onClick: function() {
                    window.open("https://1point.kr/blog/insights/");
                },
                children: "더 보러가기"
            })
        ]
    });
};
var FAQSection = function() {
    //
    var a = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ContentsContainer, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionTitle, {
                children: "자주 묻는 질문"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__/* .EmptySpace */ .zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: _src_model_applicationModel__WEBPACK_IMPORTED_MODULE_8__/* .faqListClient[0].map */ .np[0].map(function(faq, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CustomAccordion, {
                        defaultExpanded: i === 0,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_AccordionSummary__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                    htmlColor: "black"
                                }),
                                sx: {
                                    color: "var(--card-bg)",
                                    fontSize: "14px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FAQAnswerTitle, {
                                    children: [
                                        "Q. ",
                                        faq.title
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_AccordionDetails__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                sx: {
                                    color: "black",
                                    whiteSpace: "pre-wrap",
                                    background: "white",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "start",
                                    gap: "20px",
                                    paddingBottom: "20px",
                                    border: "none"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FAQAnswerDiv, {
                                    children: faq.answer
                                })
                            })
                        ]
                    }, "accordion-faq-".concat(i));
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_6__/* .EmptySpace */ .zV, {
                space: 120
            })
        ]
    });
};
var HowToAnswerDiv = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject10());
var HowAnswerDiv = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject11());
var FAQAnswerDiv = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject12());
var CtaImageBox = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject13());
var MainCtaButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(_templateObject14());
var BlogCtaButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(_templateObject15());
var MatinCtaContentsInner = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject16());
var MainCtaContentsContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject17());
var WhyCardList = [
    {
        imgSrc: "/onepoint/images/renewal/why-section/why1.png",
        title: "정규직 채용이 부담스러워요",
        subTitle: "잘하는 마케터가 필요하나 파트타임을 원하거나,\n사업 변동성이 커서 유연한 고용이 필요할 때"
    },
    {
        imgSrc: "/onepoint/images/renewal/why-section/why2.png",
        title: "신규 전략 수립이 필요합니다",
        subTitle: "대행사가 깊이 고민해주지 않아서 아쉽거나,\n새로운 전략 수립이 필요하나 CMO가 없을 때"
    },
    {
        imgSrc: "/onepoint/images/renewal/why-section/why3.png",
        title: "내부 역량 강화를 원합니다",
        subTitle: "대표/임원이 직접 배워 시스템을 구축하고 싶거나,\n내부 주니어 마케터의 사수가 필요할 때"
    },
    {
        imgSrc: "/onepoint/images/renewal/why-section/why4.png",
        title: "특정 전문성이 단기로 필요합니다",
        subTitle: "새로운 시도를 위해 특정 스킬/경험이 필요하거나,\n기존 마케팅 방식과 시스템을 점검받고 싶을 때"
    }, 
];
var WhyCard = function(props) {
    var imgSrc = props.imgSrc, title = props.title, subTitle = props.subTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WhyCardBoxMobile, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                style: {
                    width: "36px",
                    height: "36px"
                },
                src: imgSrc,
                alt: ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_9__/* .GroupA */ .so, {
                order: "column-start-start",
                gap: 8,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "subTitle",
                        children: subTitle
                    })
                ]
            })
        ]
    });
};
var WhyCardBoxMobile = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject18());
var ProcessCardList = [
    {
        imgSrc: "/onepoint/images/renewal/process/process_1.png",
        title: "매칭 컨설팅",
        subTitle: "마케터 출신의 매칭 컨설턴트와\n요청 업무에 대해 논의합니다."
    },
    {
        imgSrc: "/onepoint/images/renewal/process/process_2.png",
        title: "최적 매칭",
        subTitle: "개별 기업의 특성과 니즈에 맞춘\n최적 전문가를 추천받습니다."
    },
    {
        imgSrc: "/onepoint/images/renewal/process/process_3.png",
        title: "인터뷰",
        subTitle: "화상 미팅을 통해 전문가의\n역량과 적극성을 검증합니다."
    },
    {
        imgSrc: "/onepoint/images/renewal/process/process_4.png",
        title: "계약",
        subTitle: "계약 사항 협의를 완료하고\n전문가와 업무를 시작합니다."
    }, 
];
var ProcessCard = function(props) {
    var imgSrc = props.imgSrc, title = props.title, subTitle = props.subTitle;
    return /*#__PURE__*/ _jsxs(ProcessCardBox, {
        className: "column-start-center",
        children: [
            /*#__PURE__*/ _jsxs(GroupA, {
                order: "row-center-center",
                gap: 8,
                children: [
                    /*#__PURE__*/ _jsx(WebpImage, {
                        src: imgSrc,
                        alt: "",
                        style: {
                            width: "36px",
                            height: "36px"
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "title",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "subTitle",
                children: subTitle
            })
        ]
    });
};
var ProcessCardBox = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject19());
var ConsultantCardListBox = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject20());
var ReviewCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject21());
var ConsultantCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject22());
var MainContentsContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject23());
var ContentsContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section */ .Z.section(_templateObject24());
var SectionTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject25());
var SectionLargeTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject26());
var SectionTitleLeft = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject27());
var SectionSubTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject28());
var SectionSmallTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject29());
var SectionSmallSubTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject30());
var SectionSmallSubTitle2 = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject31());
var profileDataArray = [
    {
        name: "hani",
        job: "콘텐츠\xb7브랜드 마케터 7년차",
        introduction: "다양한 규모의 인하우스 경험을 바탕으로\n온\xb7오프라인 브랜드 마케팅 전략과 실무를\n모두 수행하는 전략형 마케터",
        tagList: [
            "뷰티/화장품",
            "라이프스타일",
            "F&B",
            "SaaS"
        ],
        skillList: [
            "Google",
            "Meta",
            "LinkedIn",
            "네이버",
            "카카오",
            "콘텐츠 기획"
        ],
        imageUrl: "/onepoint/assets/images/main/profile/hani.jpg",
        profileUrl: "https://notion.1point.kr/expert/profile/hani"
    },
    {
        "name": "강제인",
        "job": "콘텐츠 마케터 9년차",
        "introduction": "브랜드 맥락을 기반으로\n콘텐츠와 크리에이티브를 설계하고\n성과로 연결하는 콘텐츠 마케터",
        "tagList": [
            "여행/레저",
            "교육",
            "SaaS",
            "플랫폼"
        ],
        "skillList": [
            "콘텐츠 기획/전략",
            "소재/상세 페이지 기획",
            "Figma",
            "Meta"
        ],
        "imageUrl": "/onepoint/assets/images/main/profile/kangjane.jpg",
        "profileUrl": "https://notion.1point.kr/expert/profile/kangjane"
    },
    {
        name: "댄디라이언",
        job: "콘텐츠 마케터 14년차",
        introduction: "기획부터 디자인\xb7제작까지 전 과정을 아우르며\n감각적인 콘텐츠로 브랜드 스토리를 만드는\n올인원 콘텐츠\xb7브랜딩 마케터",
        tagList: [
            "레저",
            "여행/아웃도어/부동산",
            "스포츠/패션",
            "자동차"
        ],
        skillList: [
            "바이럴 마케팅",
            "콘텐츠 마케팅",
            "Meta",
            "네이버 SNS"
        ],
        imageUrl: "/onepoint/assets/images/main/profile/dandylion.jpg",
        profileUrl: "https://notion.1point.kr/expert/profile/dandylion"
    },
    {
        name: "루시",
        job: "퍼포먼스 마케터 9년차",
        introduction: "콘텐츠\xb7브랜딩\xb7퍼포먼스를 아우르는\n경험과 10명 규모 팀 리딩 경험을 보유한\n시니어 퍼포먼스 마케터",
        tagList: [
            "뷰티/화장품",
            "패션",
            "앱 ",
            "SNS",
            "글로벌"
        ],
        skillList: [
            "Google",
            "Meta",
            "네이버",
            "카카오",
            "퍼포먼스 전략", 
        ],
        imageUrl: "/onepoint/assets/images/main/profile/lucy.jpg",
        profileUrl: "https://notion.1point.kr/expert/profile/lucy"
    },
    // {
    // 	name: "제이",
    // 	job: "그로스 마케터 11년차",
    // 	introduction:
    // 		"재미와 의미가 있는 일을 찾아\n문제를 정의하고 해결하는\n11년차 그로스 마케터",
    // 	tagList: ["커머스", "인사/비즈니스", "교육"],
    // 	skillList: ["마케팅전략", "데이터분석", "Meta", "Google"],
    // 	imageUrl: "/onepoint/assets/images/main/profile/jay.jpg",
    // 	profileUrl: "https://notion.1point.kr/expert/profile/jay",
    // },
    // {
    // 	name: "데이",
    // 	job: "퍼포먼스 마케터 10년차",
    // 	introduction: "Meta 전문, 커머스 전문\n10년차 퍼포먼스마케터\n\n",
    // 	tagList: ["패션", "홈리빙/생활용품", "유아동"],
    // 	skillList: ["Meta", "네이버", "카카오"],
    // 	imageUrl: "/onepoint/assets/images/main/profile/day.jpg",
    // 	profileUrl: "https://notion.1point.kr/expert/profile/day",
    // },
    {
        name: "M-J",
        job: "퍼포먼스 마케터 7년차",
        introduction: "서비스 중심 B2C부터\n채용/교육/SaaS 분야 B2B까지\n다양한 광고 운영 이력의 전문 마케터",
        tagList: [
            "솔루션",
            "교육",
            "인사/비즈니스"
        ],
        skillList: [
            "GA/GTM",
            "마케팅전략",
            "데이터분석"
        ],
        imageUrl: "/onepoint/assets/images/main/profile/mj.jpg",
        profileUrl: "https://notion.1point.kr/expert/profile/mj"
    },
    // {
    // 	name: "Max",
    // 	job: "PM/PO 5년차",
    // 	introduction:
    // 		"브랜드 운영에 최적화된 이력과\n세일즈&광고 구조화 역량을 갖춘\n올라운더 프로젝트 리더",
    // 	tagList: ["커머스", "뷰티/화장품", "헬스케어/바이오"],
    // 	skillList: ["광고구조화", "콘텐츠기획", "프로젝트리딩"],
    // 	imageUrl: "/onepoint/assets/images/main/profile/son.jpeg",
    // 	profileUrl: "https://notion.1point.kr/expert/profile/max",
    // },
    // {
    // 	name: "Claire",
    // 	job: "그로스 마케터 12년차",
    // 	introduction:
    // 		"글로벌 대기업부터 스타트업까지\n다양한 마케팅 리드 경험으로\n딱 필요한 마케팅 전략을 제시하는 전문가",
    // 	tagList: ["헬스케어/바이오", "컨텐츠/예술", "제조/하드웨어"],
    // 	skillList: ["마케팅전략", "브랜드전략", "SEM"],
    // 	imageUrl: "/onepoint/assets/images/main/profile/claire.jpg",
    // 	profileUrl: "https://notion.1point.kr/expert/profile/claire",
    // },
    {
        name: "hidy",
        job: "그로스 마케터 7년차",
        introduction: "유입부터 재구매까지\n비즈니스의 성장에 필요한 A to Z를\n디스커션 할 수 있는 시니어 마케터",
        tagList: [
            "커머스",
            "패션",
            "뷰티/화장품"
        ],
        skillList: [
            "소재기획",
            "이미지/영상제작",
            "콘텐츠기획"
        ],
        imageUrl: "/onepoint/assets/images/main/profile/hidy.jpg",
        profileUrl: "https://notion.1point.kr/expert/profile/hidy"
    }
];
var SwiperSectionContents = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ContentsContainer)(_templateObject32());
var SubscribeInput = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input */ .Z.input(_templateObject33());
var SubscribeButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_lab__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(_templateObject34());
var SectionRight = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject35());
var FAQButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(_templateObject36());
var FAQAnswerTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject37());
var AnswerListUl = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ul */ .Z.ul(_templateObject38());
var FAQAnswerListUl = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ul */ .Z.ul(_templateObject39());
var FAQAnswerList = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].li */ .Z.li(_templateObject40());
var ConsultantUserList = [
    {
        imgSrc: "/onepoint/images/consultant/jeon.jpg",
        name: "전준현",
        desc: "퍼포먼스 마케터 2년차"
    }, 
];
var CListPagination = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject41());
var ReviewContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject42());
var ReviewData = [
    {
        title: "업계 최고 수준의 마케터를 필요할 때마다 합리적으로",
        description: "원포인트는 업계 최고 수준의 마케터를, 필요할 때마다 합리적인 가격으로 활용할 수 있는 서비스입니다.",
        company: "아파트멘터리",
        name: "하아얀",
        position: "전략실장",
        img: "/onepoint/images/renewal/review-section/1-1.png"
    },
    {
        title: "마케팅, 헤매지 않고 시작하는 법",
        description: "신규 조직에 내부 전담 인력이 없는 상태에서 GA세팅부터 광고 운영까지, 성공적으로 디지털 마케팅을 시작할 수 있었습니다. 단순 운영 대행이 아닌, 함께 고민하는 파트너와 일하는 것 같아 정말 좋았습니다.",
        company: "한화솔루션",
        name: "김수현",
        position: "프로",
        img: "/onepoint/images/renewal/review-section/1-2.png"
    },
    {
        title: "전문가 퀄리티에 놀랐습니다",
        description: "저희가 쉽게 채용할 수 없는 분과, 원하는 기간 만큼만 함께 일할 수 있어서 좋았고 큰 도움을 받았습니다. 특히 전문가 퀄리티에 놀랐습니다.",
        company: "샐러디",
        name: "이건호",
        position: "대표",
        img: "/onepoint/images/renewal/review-section/1-3.png"
    },
    {
        title: "초기 스타트업에게 최고의 선택",
        description: "마케터가 필요하지만 정규직 고용은 부담스럽다보니 원포인트를 통해 파트타임 전문가를 고용했습니다. 시간내에 큰 성과를 내기 위해 진심으로 일해주시는 역량있는 마케터를 만나서 많은 도움이 되었습니다.",
        company: "패러닷",
        name: "장진욱",
        position: "대표",
        img: "/onepoint/images/renewal/review-section/1-4.png"
    },
    {
        title: "정규직 채용과 외주 활용 부담을 해결했어요",
        description: "정규직을 채용하기에는 제약이 많고, 검증되지 않은 곳에 외주를 맡기기도 부담스러웠습니다. 원포인트를 통해 시간제로 역량있는 마케터와 일할 수 있어 이러한 갈증이 해결되었습니다.",
        company: "셀러노트",
        name: "이종원",
        position: "대표",
        img: "/onepoint/images/renewal/review-section/1-5.png"
    },
    {
        title: "비용이 반으로 줄었는데 성과가 개선됐어요",
        description: "마케터 채용 비용의 50%로 실적은 계속적으로 향상되고 있어요! 좋은 시니어 마케터분을 찾으신다면 관리까지 꼼꼼하게 해주는 원포인트 추천합니다!",
        company: "소프트스퀘어드",
        name: "윤수진",
        position: "",
        img: "/onepoint/images/renewal/review-section/1-6.png"
    },
    {
        title: "더 이상 헤매지 않고 마케팅을 하게 되었습니다",
        description: "마케팅은 경험이 중요하다고 생각합니다. 고급 숙련자의 경험을 바탕으로 마케팅을 진행하고 배울 수 있어서 추천합니다. 더 이상 주니어들끼리 헤매지 않아도 됩니다.",
        company: "투어라이브",
        name: "노경아",
        position: "대표",
        img: "/onepoint/images/renewal/review-section/1-7.png"
    },
    {
        title: "광고 성과가 많이 올랐습니다",
        description: "실력있는 인재와 함께하는 것이 좋은 성과의 핵심인데, 원포인트에서 만난 마케팅 전문가님의 도움으로 성과가 많이 올랐습니다",
        company: "펫박스",
        name: "이현석",
        position: "대표",
        img: "/onepoint/images/renewal/review-section/1-8.png"
    },
    {
        title: "더 이상 대행사를 쓰지 않습니다",
        description: "마케팅 대행사를 세 곳 정도 써보았지만 모두 마음에 들지 않았습니다. 결국 지금은 원포인트를 통해 숙련된 퍼포먼스 마케터를 파트타임으로 활용하고 있는데, 알아서 캠페인 퍼포먼스 관리를 잘 해주시니 정말 편리합니다.",
        company: "에딧메이트",
        name: "최범익",
        position: "대표",
        img: "/onepoint/images/renewal/review-section/1-9.png"
    }, 
];
var BpCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject43());
var BpList = [
    {
        name: "마케팅 캠페인",
        title: "샐러디는 어떻게 배달앱 인기 검색어 1위에 올랐을까?",
        imgSrc: "/onepoint/assets/images/main/example/bp_salady.png",
        url: "https://1point.kr/blog/best-practices/salady/"
    },
    {
        name: "콘텐츠 마케팅",
        title: "580억 투자 받은 아파트멘터리가 잘하는 마케터 고용한 방법",
        imgSrc: "/onepoint/assets/images/main/example/bp_ap.png",
        url: "https://1point.kr/blog/best-practices/apartmentary/"
    },
    {
        name: "콘텐츠 마케팅",
        title: "MZ세대 대세 서비스 패러닷이\n대박 콘텐츠를 만들어낸 노하우",
        imgSrc: "/onepoint/assets/images/main/example/paradot.png",
        url: "https://1point.kr/blog/best-practices/paradot/"
    },
    {
        name: "퍼포먼스 마케팅",
        title: "트렌드아이는 어떻게 마케터 채용에\n드는 시간과 비용을 줄였을까?",
        imgSrc: "/onepoint/assets/images/main/example/bp_wdressroom.png",
        url: "https://1point.kr/blog/best-practices/trend-i/"
    },
    {
        name: "그로스 마케팅",
        title: "초기 스타트업 리클이\n경력직 마케터 채용 대신 선택한 것",
        imgSrc: "/onepoint/assets/images/main/example/bp_recl.png",
        url: "https://1point.kr/blog/best-practices/recl/"
    },
    {
        name: "브랜드 마케팅",
        title: "닥터이브가 마케터 정규직 없이\n3개월만에 매출 월 1억을 달성한 방법",
        imgSrc: "/onepoint/assets/images/main/example/purposed-dreve.png",
        url: "https://1point.kr/blog/best-practices/purposed-dreve/"
    }, 
];
var BigInsightCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject44());
var InsightCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject45());
var InsightList = [
    {
        name: "연준현",
        title: "초기 스타트업을 위한 마케팅 가이드",
        type: "인사이트",
        imgSrc: "/onepoint/images/renewal/insight-section/1.png",
        url: "https://1point.kr/blog/insights/startup-marketing-guide/",
        text: "초기 스타트업, 어떤 마케팅을 해야 할까요? 라이브 커머스, SEO/SEM, 퍼포먼스, 그로스, 브랜드, 이메일, CPA, 트래픽, 제휴, 콘텐츠 등 이 많은 마케팅 방법 중 초기 스타트업은 어떤 것을 선택해야 할지 목적과 수단에 따른 마케팅에 대해 알아봅니다."
    },
    {
        name: "레비",
        title: "개발 지식 없이 페이스북 픽셀 설치하는 법",
        type: "인사이트",
        imgSrc: "/onepoint/images/renewal/insight-section/2.png",
        url: "https://1point.kr/blog/insights/meta-pixel-1/"
    },
    {
        name: "데이",
        title: "인스타 광고 vs 메타 광고 3가지 차이점 탐구",
        type: "인사이트",
        imgSrc: "/onepoint/images/renewal/insight-section/3.png",
        url: "https://1point.kr/blog/insights/instagram-vs-meta/"
    },
    {
        name: "콘텐츠온",
        title: "B2B 마케팅에서 고객을 효과적으로 설득하는 방법",
        type: "인사이트",
        imgSrc: "/onepoint/images/renewal/insight-section/4.png",
        url: "https://1point.kr/blog/insights/b2b-success-cases/"
    },
    {
        name: "Miguel",
        title: "퍼포먼스 vs 그로스 마케팅, 차이점과 적용 시기",
        type: "인사이트",
        imgSrc: "/onepoint/images/renewal/insight-section/5.png",
        url: "https://1point.kr/blog/insights/growth-performance-difference/"
    }, 
];
var CustomAccordion = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Accordion__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(_templateObject46());
var slideUpFadeMobile = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .keyframes */ .F4)(_templateObject47());
var MobileRollingTextSpan = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .Z.span(_templateObject48(), slideUpFadeMobile);


/***/ }),

/***/ 33827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ MainContents; },
/* harmony export */   "v": function() { return /* binding */ FAQSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(23508);
/* harmony import */ var _mui_material_AccordionDetails__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(47028);
/* harmony import */ var _mui_material_AccordionSummary__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(29618);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(29630);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(70917);
/* harmony import */ var _src_api_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67514);
/* harmony import */ var _src_api_sign__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28702);
/* harmony import */ var _src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76445);
/* harmony import */ var _src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34489);
/* harmony import */ var _src_hook_useUser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92859);
/* harmony import */ var _src_model_applicationModel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21594);
/* harmony import */ var _src_ruix__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9869);
/* harmony import */ var _src_state__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51413);
/* harmony import */ var _src_utils_sign__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(57386);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1785);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react_gtm_module__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4480);
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(94135);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(48929);
/* harmony import */ var _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(17805);
/* harmony import */ var _mobile_MainContentsMobile__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70436);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(77366);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n					.how-to-verify {\n						border-radius: 20px;\n						overflow: hidden;\n						transition: transform 0.2s ease;\n\n						&:hover {\n							transform: translateY(-4px);\n						}\n					}\n				"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	border-radius: 16px;\n	overflow: hidden;\n	box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);\n	width: 100%;\n	max-width: 800px;\n	margin: 0 auto;\n\n	& > * {\n		margin: 0 !important;\n		border-radius: 0 !important;\n		box-shadow: none !important;\n	}\n\n	& > *:not(:last-child) {\n		border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
























var MainContents = function() {
    var user = (0,_src_hook_useUser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().user;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    var setIsApplyOpen = (0,recoil__WEBPACK_IMPORTED_MODULE_13__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_9__/* .isApplyOpenAtom */ .Vu);
    var setIsChatOpen = (0,recoil__WEBPACK_IMPORTED_MODULE_13__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_9__/* .isChatOpenAtom */ .P2);
    var userInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_13__/* .useRecoilValue */ .sJ)(_src_state__WEBPACK_IMPORTED_MODULE_9__/* .userInfoAtom */ .wl);
    var setDefaultMessage = (0,recoil__WEBPACK_IMPORTED_MODULE_13__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_9__/* .defaultMessageAtom */ .Em);
    var setSnackbareState = (0,recoil__WEBPACK_IMPORTED_MODULE_13__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_9__/* .globalSnackbarState */ .j8);
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        var scrollFunction = function() {
            var ref;
            if (scrollY > ((ref = document.querySelector("#client-apply-mid")) === null || ref === void 0 ? void 0 : ref.offsetHeight)) {
                var ref1;
                (ref1 = document.querySelector(".floating")) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("hidden");
            } else {
                var ref2;
                (ref2 = document.querySelector(".floating")) === null || ref2 === void 0 ? void 0 : ref2.classList.add("hidden");
            }
        };
        window.addEventListener("scroll", scrollFunction);
        return function() {
            window === null || window === void 0 ? void 0 : window.removeEventListener("scroll", scrollFunction);
        };
    }, []);
    var 플로팅버튼 = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "floating column-center-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                onClick: function() {
                    if (user.isLogin && user.userType === 2) {
                        setSnackbareState("고객사 전용 서비스입니다.\n문의사항은 우측 하단 채널톡을 이용해주시기 바랍니다.");
                        return;
                    }
                    var tagManagerArgs = {
                        dataLayer: {
                            event: "client-apply-start"
                        }
                    };
                    if (!window.localStorage.getItem("accessToken")) {
                        react_gtm_module__WEBPACK_IMPORTED_MODULE_12___default().dataLayer(tagManagerArgs);
                    }
                    setDefaultMessage("");
                    if (user.isLogin) {
                        setIsChatOpen(true);
                    } else {
                        setIsApplyOpen(true);
                    }
                },
                className: "floating-btn-apply apply-button",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    children: "지금 바로 상담 받기"
                })
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .Global */ .xB, {
                styles: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .css */ .iv)(_templateObject())
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .MainContentsContainer */ .AF, {
                className: "column-center-start",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MainCtaContents, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CIList, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WhenWeNeed, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HowToVerify, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ExpertList, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GetProfileNewsLetter, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Purpose, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Process, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BestPractice, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ReviewList, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlogSection, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FAQSection, {
                        list: _src_model_applicationModel__WEBPACK_IMPORTED_MODULE_7__/* .faqListClient[0] */ .np[0]
                    }),
                    플로팅버튼()
                ]
            })
        ]
    });
};
var rollingNumbers = [
    "5",
    "10",
    "20"
];
var MainCtaContents = function() {
    var user = (0,_src_hook_useUser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().user;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    var setIsApplyOpen = (0,recoil__WEBPACK_IMPORTED_MODULE_13__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_9__/* .isApplyOpenAtom */ .Vu);
    var setIsChatOpen = (0,recoil__WEBPACK_IMPORTED_MODULE_13__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_9__/* .isChatOpenAtom */ .P2);
    var userInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_13__/* .useRecoilValue */ .sJ)(_src_state__WEBPACK_IMPORTED_MODULE_9__/* .userInfoAtom */ .wl);
    var setDefaultMessage = (0,recoil__WEBPACK_IMPORTED_MODULE_13__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_9__/* .defaultMessageAtom */ .Em);
    var setSnackbareState = (0,recoil__WEBPACK_IMPORTED_MODULE_13__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_9__/* .globalSnackbarState */ .j8);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(0), numIndex = ref[0], setNumIndex = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        var interval = setInterval(function() {
            setNumIndex(function(prev) {
                return (prev + 1) % rollingNumbers.length;
            });
        }, 2500);
        return function() {
            return clearInterval(interval);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .MainCtaContentsContainer */ .XX, {
        className: "column-center-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ContentsContainer */ .y3, {
            className: "column-center-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .MainCtaContentsInner */ .DO, {
                className: "column-center-start",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h1", {
                        className: "cta-title-box",
                        style: {
                            margin: "0 auto"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "row-center-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                    children: [
                                        "상위 ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: "blue",
                                            children: "10%"
                                        }),
                                        " 마케터를"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        children: "주"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .RollingTextSpan */ .YT, {
                                        className: "blue",
                                        children: rollingNumbers[numIndex]
                                    }, numIndex),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        children: "시간 고용하세요"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__/* .EmptySpace */ .zV, {
                        space: 20
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .MainCtaButton */ .T8, {
                        variant: "contained",
                        id: "client-apply-mid",
                        className: "apply-button",
                        onClick: function() {
                            if (user.isLogin && user.userType === 2) {
                                setSnackbareState("고객사 전용 서비스입니다.\n문의사항은 우측 하단 채널톡을 이용해주시기 바랍니다.");
                                return;
                            }
                            var tagManagerArgs = {
                                dataLayer: {
                                    event: "client-apply-start"
                                }
                            };
                            if (!window.localStorage.getItem("accessToken")) {
                                react_gtm_module__WEBPACK_IMPORTED_MODULE_12___default().dataLayer(tagManagerArgs);
                            }
                            setDefaultMessage("");
                            if (user.isLogin) {
                                setIsChatOpen(true);
                            } else {
                                setIsApplyOpen(true);
                            }
                        },
                        children: "지금 바로 상담 받기"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        onClick: function() {
                            setDefaultMessage("안녕하세요! 원포인트 AI 마케팅 상담봇입니다 \uD83D\uDE42\n\n회사나 브랜드, 혹은 현재 상황이나 고민하고 계신 부분에 대해 편하게 말씀해주시면 차근차근 도와드릴게요!");
                            if (user.isLogin && user.userType === 2) {
                                setSnackbareState("고객사 전용 서비스입니다.\n문의사항은 우측 하단 채널톡을 이용해주시기 바랍니다.");
                                return;
                            }
                            if (user.isLogin) {
                                setIsChatOpen(true);
                            } else {
                                setIsApplyOpen(true);
                            }
                        },
                        className: "ai-consult-button",
                        style: {
                            color: "#666666",
                            textDecoration: "none",
                            cursor: "pointer",
                            fontSize: "14px",
                            marginTop: "12px",
                            transition: "all 0.2s ease",
                            borderBottom: "1px solid transparent",
                            paddingBottom: "2px",
                            letterSpacing: "-0.3px"
                        },
                        onMouseEnter: function(e) {
                            e.currentTarget.style.borderBottom = "1px solid #666666";
                        },
                        onMouseLeave: function(e) {
                            e.currentTarget.style.borderBottom = "1px solid transparent";
                        },
                        children: "5분 안에 마케팅 진단 먼저 받아보기"
                    })
                ]
            })
        })
    });
};
var WhenWeNeed = function() {
    var a = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ContentsContainer */ .y3, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                order: "column-start-center",
                gap: 20,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SectionTitle */ .NZ, {
                    children: "검증된 탑티어 프리랜서 마케터,\n언제 필요할까요?"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__/* .EmptySpace */ .zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .PaperA */ .iV, {
                variant: "transparent",
                order: "row-start-between",
                gap: 8,
                px: 0,
                py: 0,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCard */ .nJ, {
                        imgSrc: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCardList[0].imgSrc */ .O_[0].imgSrc,
                        title: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCardList[0].title */ .O_[0].title,
                        subTitle: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCardList[0].subTitle */ .O_[0].subTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCard */ .nJ, {
                        imgSrc: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCardList[1].imgSrc */ .O_[1].imgSrc,
                        title: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCardList[1].title */ .O_[1].title,
                        subTitle: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCardList[1].subTitle */ .O_[1].subTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__/* .EmptySpace */ .zV, {
                space: 8
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .PaperA */ .iV, {
                variant: "transparent",
                order: "row-start-between",
                gap: 8,
                px: 0,
                py: 0,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCard */ .nJ, {
                        imgSrc: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCardList[2].imgSrc */ .O_[2].imgSrc,
                        title: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCardList[2].title */ .O_[2].title,
                        subTitle: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCardList[2].subTitle */ .O_[2].subTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCard */ .nJ, {
                        imgSrc: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCardList[3].imgSrc */ .O_[3].imgSrc,
                        title: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCardList[3].title */ .O_[3].title,
                        subTitle: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .WhyCardList[3].subTitle */ .O_[3].subTitle
                    })
                ]
            })
        ]
    });
};
var HowToVerify = function() {
    var ref = (0,_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .useModal */ .dd)(), openModal = ref.openModal, isOpen = ref.isOpen, closeModal = ref.closeModal;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        if (router.query["expert-evaluation-example"] === "true") {
            openModal();
        }
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ContentsContainer */ .y3, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ContentsContainer */ .y3, {
                className: "column-center-start how-to-verify",
                style: {
                    background: "var(--bg-white)",
                    padding: 0
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .Empty */ .HY, {
                        space: 95
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SectionTitle */ .NZ, {
                        children: "3단계 검증 시스템으로"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .HowToVerrifyBigTitle */ .cw, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                className: "blue",
                                children: "상위 10% 마케터"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: "를 선발합니다"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .Empty */ .HY, {
                        space: 80
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "row-start-start",
                        style: {
                            width: "100%",
                            height: "560px",
                            paddingLeft: "116px"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                style: {
                                    paddingRight: "53px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .Empty */ .HY, {
                                        space: 10
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                        order: "column-start-start",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .HowToVerifyStepTitle */ .dO, {
                                                style: {
                                                    width: 40
                                                },
                                                children: "1단계"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .HowtoSectionSmallTitle */ .IH, {
                                                children: "서류 평가"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .FAQAnswerDiv2 */ .wt, {
                                                children: "이력, 프로젝트 경험, 포트폴리오를 기반으로\n경력과 성과를 확인합니다"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .Empty */ .HY, {
                                        space: 90
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                        order: "column-start-start",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .HowToVerifyStepTitle */ .dO, {
                                                style: {
                                                    width: 40
                                                },
                                                children: "2단계"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .HowtoSectionSmallTitle */ .IH, {
                                                children: "역량 평가"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .FAQAnswerDiv2 */ .wt, {
                                                children: "논술형 평가를 통해\n직무별 문제 해결 역량과 스킬을 파악합니다"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .Empty */ .HY, {
                                        space: 100
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                        order: "column-start-start",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .HowToVerifyStepTitle */ .dO, {
                                                style: {
                                                    width: 40
                                                },
                                                children: "3단계"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .HowtoSectionSmallTitle */ .IH, {
                                                children: "심층 면접"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .FAQAnswerDiv2 */ .wt, {
                                                children: "커뮤니케이션 역량 및\n적극성 등 소프트 스킬을 검증합니다"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                width: 184,
                                src: "/onepoint/images/renewal/how-section/diagram.png",
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "column-center-end",
                                style: {
                                    justifyContent: "flex-end",
                                    alignItems: "flex-end"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .Empty */ .HY, {
                                        space: 35
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        style: {
                                            paddingRight: "187px"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                            order: "column-start-start",
                                            gap: 0,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .PentagonSubTitle */ .xg, {
                                                    children: "합격률"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                                    order: "row-center-start",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .PentagonTitle */ .dc, {
                                                            children: "70"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .PentagonTitle2 */ .JU, {
                                                            children: "%"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .Empty */ .HY, {
                                        space: 145
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        style: {
                                            paddingRight: "203px"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                            order: "column-start-start",
                                            gap: 0,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .PentagonSubTitle */ .xg, {
                                                    children: "합격률"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                                    order: "row-center-start",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .PentagonTitle */ .dc, {
                                                            children: "30"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .PentagonTitle2 */ .JU, {
                                                            children: "%"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .Empty */ .HY, {
                                        space: 132
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        style: {
                                            paddingRight: "229px"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                            order: "column-start-start",
                                            gap: 0,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .PentagonSubTitle */ .xg, {
                                                    children: "합격률"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                                    order: "row-center-start",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .PentagonTitle */ .dc, {
                                                            children: "10"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .PentagonTitle2 */ .JU, {
                                                            children: "%"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .Empty */ .HY, {
                        space: 80
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .BlogCtaButton */ .kj, {
                        variant: "contained",
                        onClick: openModal,
                        children: "실제 역량 평가 사례가 궁금하다면?"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__/* .EmptySpace */ .zV, {
                        space: 40
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .ModalA */ .zk, {
                zIndex: 10001,
                maxWidth: "800px",
                bgColor: "white",
                isOpen: isOpen,
                onClose: closeModal,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .PaperA */ .iV, {
                    variant: "transparent",
                    order: "column-center-center",
                    gap: 16,
                    px: 16,
                    py: 0,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SectionSmallTitle */ .tx, {
                            children: "실제 역량 평가 문제 & 답변"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .PaperA */ .iV, {
                            variant: "transparent",
                            order: "column-center-center",
                            gap: 30,
                            px: 16,
                            py: 0,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SectionSmallSubTitle */ .$N, {
                                    children: "당신은 글로벌 가전 브랜드 Dyson의 디지털 마케팅팀에서 최근 출시한 프리미엄 공기청정기 라인의 온라인 광고 캠페인을 담당하고 있습니다. 지난 분기 동안 이 제품 라인의 자사 온라인 스토어 판매가 예상보다 저조했으며, 특히 주요 타겟 그룹에서의 구매 전환율이 낮은 것으로 나타났습니다. 초기 분석 결과, 주요 원인으로는 다음 두 가지가 지목되었습니다."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SectionSmallSubTitle2 */ .P2, {
                                    children: [
                                        "1. 경쟁 브랜드들의 공격적인 마케팅으로 인한 시장 점유율 감소 ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                        "2. 소비자들의 높은 가격 민감도와 경기 불황으로 인한 구매 의사 결정 지연"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SectionSmallSubTitle */ .$N, {
                                    children: "온라인 광고 성과는 전반적으로 기대에 미치지 못하고 있으며, 특히 광고 클릭에서 실제 구매로 이어지는 전환율이 낮은 상황입니다. 현재 상황을 어떻게 분석하고 온라인 광고에서의 전환율 향상을 위해 어떤 전략과 액션을 수행할지 서술하세요."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__/* .EmptySpace */ .zV, {
                            space: 20
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            style: {
                                maxWidth: "100%",
                                padding: "0 32px"
                            },
                            src: "/onepoint/images/renewal/how-section/example.png",
                            alt: ""
                        })
                    ]
                })
            })
        ]
    });
};
var ExpertList = function() {
    var a = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SwiperSectionContents */ .xR, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .PaperA */ .iV, {
                variant: "transparent",
                order: "row-end-between",
                gap: 20,
                px: 16,
                py: 0,
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SectionTitleLeft */ .rI, {
                        children: "원포인트 자체 검증 시스템을 거친\n탑티어 전문가를 만나보세요"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "swiper-pagination"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__/* .EmptySpace */ .zV, {
                space: 80
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
                className: "profile-box",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_15__/* .Swiper */ .tq, {
                    navigation: {
                        nextEl: ".swiper-button-next-unique",
                        prevEl: ".swiper-button-prev-unique"
                    },
                    modules: [
                        swiper_modules__WEBPACK_IMPORTED_MODULE_14__/* .Pagination */ .tl,
                        swiper_modules__WEBPACK_IMPORTED_MODULE_14__/* .Navigation */ .W_,
                        swiper_modules__WEBPACK_IMPORTED_MODULE_14__/* .Scrollbar */ .LW,
                        swiper_modules__WEBPACK_IMPORTED_MODULE_14__/* .Autoplay */ .pt
                    ],
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    centeredSlides: false,
                    loop: true,
                    spaceBetween: 20,
                    pagination: {
                        el: ".swiper-pagination"
                    },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                        pauseOnMouseEnter: true
                    },
                    breakpoints: {
                        1023: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                            spaceBetween: 32,
                            centeredSlides: false,
                            autoplay: {
                                delay: 5000,
                                disableOnInteraction: true,
                                pauseOnMouseEnter: true
                            }
                        },
                        600: {
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                            spaceBetween: 32,
                            centeredSlides: false,
                            autoplay: {
                                delay: 5000,
                                disableOnInteraction: true,
                                pauseOnMouseEnter: true
                            }
                        }
                    },
                    children: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .profileDataArray.map */ .ci.map(function(v, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_15__/* .SwiperSlide */ .o5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "profile-item",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "top-box",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                className: "profile-img",
                                                src: v.imageUrl,
                                                alt: "".concat(v.name, " 프로필이미지")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "name",
                                                children: v.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "job",
                                                children: v.job
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                                order: "row-center-start",
                                                gap: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        src: "/onepoint/images/renewal/expert-section/verify.png",
                                                        alt: "",
                                                        style: {
                                                            width: "16px",
                                                            height: "16px"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        style: {
                                                            fontSize: "12px",
                                                            color: "var(--primary)"
                                                        },
                                                        children: "검증된 전문가"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__/* .EmptySpace */ .zV, {
                                                space: 8
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "bottom-box",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "introduction",
                                                children: v.introduction
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "skill-box",
                                                children: [
                                                    v.tagList,
                                                    v.skillList
                                                ].flat().map(function(skill, i) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "skill",
                                                        children: skill
                                                    }, "profile-skill-".concat(i));
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "go-profile",
                                                onClick: function() {
                                                    window.open(v.profileUrl, "_blank");
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    children: "프로필 보기 "
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, "profileData-".concat(i));
                    })
                })
            })
        ]
    });
};
var GetProfileNewsLetter = function() {
    var a = 1;
    var setSnackbareState = (0,recoil__WEBPACK_IMPORTED_MODULE_13__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_9__/* .globalSnackbarState */ .j8);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_11__.useState(""), 2), email = ref[0], setEmail = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_11__.useState(false), 2), isLoad = ref1[0], setIsLoad = ref1[1];
    var handleOnClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(function() {
            var _tmp, error, _tmp1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_22__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(0,_src_utils_sign__WEBPACK_IMPORTED_MODULE_23__/* .validateEmail */ .oH)(email)) return [
                            3,
                            7
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            5,
                            6
                        ]);
                        setIsLoad(true);
                        _tmp = {};
                        return [
                            4,
                            (0,_src_api_sign__WEBPACK_IMPORTED_MODULE_3__/* .subscribeStibee */ .ot)((_tmp.email = email, _tmp.type = "프로필", _tmp.ads = "O", _tmp))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        error = _state.sent();
                        _tmp1 = {};
                        return [
                            4,
                            (0,_src_api_error__WEBPACK_IMPORTED_MODULE_2__/* .sendSlackError */ .N)((_tmp1.message = "구독하기 실패" + email, _tmp1.title = "구독 프론트엔드 에러", _tmp1.channel = "error", _tmp1))
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setIsLoad(false);
                        return [
                            7
                        ];
                    case 6:
                        setSnackbareState("구독이 완료되었습니다.");
                        setEmail("");
                        return [
                            3,
                            8
                        ];
                    case 7:
                        setSnackbareState("이메일 형식이 맞지 않습니다.");
                        _state.label = 8;
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ContentsContainer */ .y3, {
        className: "row-center-between",
        style: {
            background: "var(--bg-white)",
            borderRadius: "20px",
            padding: "60px 40px",
            boxShadow: "0px 4px 24px 0px rgba(0, 0, 0, 0.07)"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SectionTitleLeft */ .rI, {
                children: "탑티어 전문가의\n프로필을 받아보세요"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                order: "column-start-start",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                        order: "row-center-center",
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SubscribeInput */ .Ks, {
                                value: email,
                                onChange: function(e) {
                                    return setEmail(e.target.value);
                                },
                                placeholder: "work@email.com"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SubscribeButton */ .Th, {
                                variant: "contained",
                                loading: isLoad,
                                id: "subscribe_profile",
                                onClick: handleOnClick,
                                children: "구독하기"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                        style: {
                            color: "var(--desc-gray)",
                            fontSize: "14px",
                            marginTop: "5px",
                            textAlign: "right",
                            letterSpacing: "-0.64px"
                        },
                        children: [
                            "구독시",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mobile_MainContentsMobile__WEBPACK_IMPORTED_MODULE_17__/* .CustomA */ .Y, {
                                style: {
                                    color: "var(--desc-gray)",
                                    letterSpacing: "-0.64px"
                                },
                                target: "_blank",
                                href: "https://notion.1point.kr/privacy",
                                rel: "noreferrer",
                                children: "개인정보 수집 및 이용"
                            }),
                            "에 동의하게 됩니다"
                        ]
                    })
                ]
            })
        ]
    });
};
var list = [
    {
        title: "퍼포먼스 마케터",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "목적에 맞는 디지털 광고 구성과 광고비 성과 최적화가 필요할 때",
                "광고비를 사용해 콘텐츠 마케팅 대비 빠른 유입/전환을 만들어야 할 때",
                "소비자 타겟 및 데이터를 광고를 통해 파악해야 할 때", 
            ],
            exList: [
                "퍼포먼스 마케팅 매체 전략 수립",
                "미디어 믹스 전략 기획",
                "소재 A/B 테스트",
                "소재 셋팅과 성과 최적화",
                "성과 분석 및 리포팅",
                "대행사 활용 시 대행사 핸들링",
                "메타/구글/네이버 키워드 등 필요 매체 운영", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog/best-practices/mj-groupby/"
            }
        }
    },
    {
        title: "브랜드 마케터",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "전반적인 브랜드 전략 수립이 필요할 때",
                "BI를 소비자에게 인식시키기 위한 장기 전략이 필요할 때",
                "소비자에게 사랑받는 브랜드 아이덴티티(BI) 구축이 필요할 때", 
            ],
            exList: [
                "브랜드 전략 수립 (컨셉/브랜드 네이밍 개발)",
                "브랜드 포지셔닝 전략 수립",
                "브랜드 컨셉 및 핵심가치 등 전략 수립",
                "브랜드 마케팅 캠페인 실행안 기획",
                "브랜드 광고 마케팅 전략 수립",
                "브랜드 마케팅 대행사 활용 시 대행사 핸들링", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog/best-practices/philip-startupcode/"
            }
        }
    },
    {
        title: "콘텐츠 마케터",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "타겟에게 적합하고 신선한 크리에이티브 기획이 필요할 때",
                "일관적인 브랜드 이미지 구축과 커뮤니케이션을 위한 콘텐츠 기획이 필요할 때",
                "SNS 초기 셋팅 시 콘텐츠의 톤앤매너와 방향성 수립이 필요할 때", 
            ],
            exList: [
                "콘텐츠 마케팅 방향성/매체 전략 수립",
                "콘텐츠 전략과 톤앤매너 전략 수립",
                "이미지/영상 콘텐츠 기획",
                "콘텐츠 발행 및 성과 분석",
                "상세 페이지 기획/개선/가이드/카피라이팅",
                "광고 소재 기획/카피라이팅", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog/best-practices/paradot/"
            }
        }
    },
    {
        title: "블로그/뉴스레터 마케터",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "장기적으로 블로그 콘텐츠를 발행해 소비자의 신뢰도를 올려야 할 때",
                "소비자가 많은 정보를 찾아보는 고관여 제품, B2B 제품 판매 시 특히 적합",
                "유저와의 커뮤니케이션으로 광고비 없이 오가닉 유입을 이끌어야 할 때", 
            ],
            exList: [
                "블로그 콘텐츠 전략과 톤앤매너 전략 수립",
                "블로그/뉴스레터 콘텐츠 기획 & 작성",
                "블로그/뉴스레터 발행 및 성과 분석", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog/best-practices/nry-boundx/"
            }
        }
    },
    {
        title: "이커머스 마케터",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "자사몰 제품 판매를 위한 마케팅 전략이 필요할 때",
                "광고 클릭율은 높은데 전환이 떨어질 때",
                "자사몰 및 상세 페이지 전반에 대한 개선과 가이드가 필요할 때", 
            ],
            exList: [
                "자사몰 전환 최적화를 위한 액션 제안과 실행",
                "제품 상세 페이지 개선 기획",
                "전환율 최적화 전략 수립",
                "이커머스 광고 캠페인 기획 및 실행",
                "성과 분석 및 리포팅",
                "대행사 활용 시 대행사 핸들링", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog/best-practices/purposed-dreve/"
            }
        }
    },
    {
        title: "CRM 마케터",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "초기 CRM 전략 및 툴 셋팅이 필요할 때",
                "고객 세그먼트를 체계적으로 관리하고 싶을 때",
                "고객 세그먼트에 맞춰 재구매와 추가 구매를 유도해야 할 때", 
            ],
            exList: [
                "CRM 툴 셋팅과 캠페인 기획&운영",
                "고객 데이터 분석",
                "고객 세그먼트화",
                "데이터를 통한 고객 만족도 조사 및 개선",
                "채널톡/이메일 캠페인 기획 및 운영", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog/"
            }
        }
    },
    {
        title: "SEO/SEM 마케터",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "검색 엔진에서 회사와 제품 상위 노출이 필요할 때",
                "검색을 통한 오가닉 유입 전략을 세우고 싶을 때", 
            ],
            exList: [
                "SEO/SEM 현황 점검/전략 도출",
                "검색 엔진 최적화 전략 수립",
                "구글 애널리틱스 분석",
                "키워드 연구 및 분석", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog/"
            }
        }
    },
    {
        title: "디자이너",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "고객에게 신뢰를 주는 일관된 브랜드 아이덴티티(BI/CI) 구축이 필요할 때",
                "사용자 경험(UX/UI)을 개선하여 웹/앱 서비스의 이탈률을 낮추고 싶을 때",
                "마케팅 메시지를 효과적으로 전달하는 상세페이지, 광고 소재 등이 필요할 때", 
            ],
            exList: [
                "브랜드 아이덴티티(로고, 컬러, 서체) 시스템 구축",
                "웹/앱 서비스의 UX/UI 설계 및 디자인",
                "상세페이지, 이벤트 페이지 등 마케팅 콘텐츠 디자인",
                "SNS 채널(인스타그램, 페이스북) 콘텐츠 디자인",
                "브로슈어, 명함 등 인쇄물 디자인",
                "전체적인 디자인 톤앤매너 수립 및 가이드라인 제작", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog"
            }
        }
    },
    {
        title: "영상 소재 제작 전문가",
        a: {
            title: "어떤 상황에 고용하나요?",
            list: [
                "제품/서비스를 매력적으로 보여줄 광고 영상이 필요할 때",
                "시선을 사로잡는 숏폼(릴스, 쇼츠) 콘텐츠를 만들고 싶을 때",
                "브랜드 스토리 등 전문적인 영상이 필요할 때",
                "콘텐츠는 있지만, 영상으로 만드는 데 어려움을 겪을 때", 
            ],
            exList: [
                "영상 소재 기획, 제작 및 편집",
                "플랫폼별 영상 최적화", 
            ],
            button: {
                text: "성공 사례 보기",
                url: "https://1point.kr/blog"
            }
        }
    }, 
];
var Purpose = function() {
    //
    var a = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ContentsContainer */ .y3, {
        className: "column-start-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                order: "column-center-center",
                gap: 20,
                fullWidth: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SectionTitle */ .NZ, {
                    children: "목적에 맞는 전문가를 매칭 받으세요"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__/* .EmptySpace */ .zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SectionRight */ .pM, {
                children: list.map(function(faq, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .CustomAccordion */ .G1, {
                        defaultExpanded: i === 0,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_AccordionSummary__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                    htmlColor: "black"
                                }),
                                sx: {
                                    color: "var(--card-bg)",
                                    paddingLeft: "24px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SectionSmallTitle */ .tx, {
                                    style: {
                                        fontSize: "22px"
                                    },
                                    children: faq.title
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_AccordionDetails__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                sx: {
                                    color: "black",
                                    whiteSpace: "pre-wrap",
                                    background: "white",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "start",
                                    gap: "20px",
                                    paddingBottom: "20px",
                                    paddingLeft: "24px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                        order: "row-start-between",
                                        gap: 12,
                                        fullWidth: true,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                                order: "column-start-start",
                                                gap: 8,
                                                fullWidth: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .FAQAnswerTitle */ .yI, {
                                                    children: faq.a.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                                order: "row-start-between",
                                                gap: 8,
                                                fullWidth: true,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .AnswerListUl */ .Jy, {
                                                        children: faq.a.list.map(function(item, index) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .FAQAnswerList */ .Bf, {
                                                                children: item
                                                            }, "faq-answer-".concat(index));
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                                                        style: {
                                                            width: "360px"
                                                        },
                                                        children: faq.a.exList.map(function(item, index) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .FAQAnswerList */ .Bf, {
                                                                children: item
                                                            }, "faq-answer-ex-".concat(index));
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .FAQButton */ .vp, {
                                        variant: "contained",
                                        onClick: function() {
                                            window.open(faq.a.button.url);
                                        },
                                        children: faq.a.button.text
                                    })
                                ]
                            })
                        ]
                    }, "accordion".concat(i));
                })
            })
        ]
    });
};
var Process = function() {
    var a = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ContentsContainer */ .y3, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                order: "column-start-center",
                gap: 20,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SectionTitle */ .NZ, {
                    children: "상담에서 계약까지 7일\n빠른 업무 투입이 가능합니다"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__/* .EmptySpace */ .zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                order: "row-start-between",
                gap: 16,
                children: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ProcessCardList.map */ .gi.map(function(item, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ProcessCard */ .WS, {
                        imgSrc: item.imgSrc,
                        title: item.title,
                        subTitle: item.subTitle
                    }, "ProcessCard" + index);
                })
            })
        ]
    });
};
var CIList = function() {
    // 로고 데이터 배열 - ci-images 폴더의 모든 파일들
    var allLogoData = [
        "/onepoint/images/renewal/ci-images/jandi.png",
        "/onepoint/images/renewal/ci-images/apartmentary.png",
        "/onepoint/images/renewal/ci-images/lgelec.png",
        "/onepoint/images/renewal/ci-images/lguplus.png",
        "/onepoint/images/renewal/ci-images/mckinsey.png",
        "/onepoint/images/renewal/ci-images/levit.png",
        "/onepoint/images/renewal/ci-images/youhan.png",
        "/onepoint/images/renewal/ci-images/dotus.png",
        "/onepoint/images/renewal/ci-images/frendliai.png",
        "/onepoint/images/renewal/ci-images/freedom.png",
        "/onepoint/images/renewal/ci-images/kearney.png",
        "/onepoint/images/renewal/ci-images/esther.png",
        "/onepoint/images/renewal/ci-images/fursys.png",
        "/onepoint/images/renewal/ci-images/celimax.png",
        "/onepoint/images/renewal/ci-images/salady.png",
        "/onepoint/images/renewal/ci-images/hanwha.png",
        "/onepoint/images/renewal/ci-images/r2w.png",
        "/onepoint/images/renewal/ci-images/heum.png",
        "/onepoint/images/renewal/ci-images/rsquare.png", 
    ];
    // 첫 번째 줄용 로고 (앞쪽 10개)
    var firstRowLogos = allLogoData.slice(0, 10);
    // 두 번째 줄용 로고 (뒤쪽 10개)
    var secondRowLogos = allLogoData.slice(10, 20);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "ci-list",
        style: {
            width: "100vw",
            marginLeft: "calc(-50vw + 50%)",
            background: "white"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                style: {
                    maxWidth: "1024px",
                    margin: "0 auto",
                    padding: "0 20px"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SectionTitle */ .NZ, {
                        children: "성장하는 기업은 원포인트를 이용합니다"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__/* .EmptySpace */ .zV, {
                        space: 40
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                style: {
                    width: "100vw",
                    overflow: "hidden",
                    padding: "0 20px"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        style: {
                            marginBottom: "30px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_15__/* .Swiper */ .tq, {
                            modules: [
                                swiper_modules__WEBPACK_IMPORTED_MODULE_14__/* .Autoplay */ .pt
                            ],
                            slidesPerView: "auto",
                            spaceBetween: 0,
                            loop: true,
                            freeMode: true,
                            dir: "rtl",
                            autoplay: {
                                delay: 0,
                                disableOnInteraction: false
                            },
                            speed: 4000,
                            style: {
                                width: "100%",
                                transitionTimingFunction: "linear"
                            },
                            children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(firstRowLogos).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(firstRowLogos), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(firstRowLogos), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(firstRowLogos), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(firstRowLogos)).map(function(logo, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_15__/* .SwiperSlide */ .o5, {
                                    style: {
                                        width: "180px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        style: {
                                            height: "70px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            transition: "all 0.3s linear"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            src: logo,
                                            alt: "company-".concat(index + 1),
                                            style: {
                                                objectFit: "contain",
                                                height: "70px"
                                            }
                                        })
                                    })
                                }, "logo-1-".concat(index));
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_15__/* .Swiper */ .tq, {
                            modules: [
                                swiper_modules__WEBPACK_IMPORTED_MODULE_14__/* .Autoplay */ .pt
                            ],
                            slidesPerView: "auto",
                            spaceBetween: 0,
                            loop: true,
                            freeMode: true,
                            autoplay: {
                                delay: 0,
                                disableOnInteraction: false
                            },
                            speed: 4000,
                            style: {
                                width: "100%",
                                transitionTimingFunction: "linear !important"
                            },
                            children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(secondRowLogos).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(secondRowLogos), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(secondRowLogos), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(secondRowLogos), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(secondRowLogos)).map(function(logo, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_15__/* .SwiperSlide */ .o5, {
                                    style: {
                                        width: "180px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        style: {
                                            height: "70px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            transition: "all 0.3s linear"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            src: logo,
                                            alt: "company-".concat(index + 1),
                                            style: {
                                                objectFit: "contain",
                                                height: "70px"
                                            }
                                        })
                                    })
                                }, "logo-2-".concat(index));
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var ReviewList = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ContentsContainer */ .y3, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ReviewContainer */ .b_, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_15__/* .Swiper */ .tq, {
                    modules: [
                        swiper_modules__WEBPACK_IMPORTED_MODULE_14__/* .Pagination */ .tl,
                        swiper_modules__WEBPACK_IMPORTED_MODULE_14__/* .Scrollbar */ .LW,
                        swiper_modules__WEBPACK_IMPORTED_MODULE_14__/* .Autoplay */ .pt
                    ],
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    centeredSlides: false,
                    loop: true,
                    spaceBetween: 20,
                    pagination: {
                        clickable: true,
                        el: ".c-list-pagination2"
                    },
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: true,
                        pauseOnMouseEnter: true
                    },
                    breakpoints: {
                        820: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                            spaceBetween: 20,
                            centeredSlides: false,
                            autoplay: {
                                delay: 5000,
                                disableOnInteraction: true,
                                pauseOnMouseEnter: true
                            }
                        }
                    },
                    children: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ReviewData.map */ ._R.map(function(v, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_15__/* .SwiperSlide */ .o5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ReviewCard */ .Ak, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                    order: "column-center-start",
                                    gap: 12,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                            order: "column-center-start",
                                            gap: 8,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "title",
                                                    children: v.title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "desc",
                                                    children: v.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                            order: "column-start-start",
                                            gap: 8,
                                            fullWidth: true,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    className: "img",
                                                    src: v.img,
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "name",
                                                    children: [
                                                        v.company,
                                                        " ",
                                                        v.name ? "| ".concat(v.name, " ").concat(v.position) : ""
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, "review-".concat(i));
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__/* .EmptySpace */ .zV, {
                space: 24
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .CListPagination */ .VH, {
                className: "c-list-pagination2 row-center-center"
            })
        ]
    });
};
var BestPractice = function() {
    //
    var a = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ContentsContainer */ .y3, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SectionTitle */ .NZ, {
                children: "원포인트 고객사의\n실제 성공 사례입니다"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .Empty */ .HY, {
                space: 40
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                order: "row-start-between",
                gap: 8,
                bgColor: "",
                style: {
                    rowGap: "16px",
                    flexWrap: "wrap"
                },
                children: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .BpList.map */ .VF.map(function(v, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .BpCard */ .Es, {
                        onClick: function() {
                            window.open(v.url);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            style: {
                                height: "100%",
                                width: "100%"
                            },
                            className: "column-start-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    className: "img",
                                    src: v.imgSrc,
                                    alt: "bp_ap.png"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .PaperA */ .iV, {
                                    variant: "transparent",
                                    px: 20,
                                    py: 20,
                                    order: "column-start-start",
                                    gap: 8,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "title",
                                            children: v.title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "card",
                                            children: v.name
                                        })
                                    ]
                                })
                            ]
                        })
                    }, "bp-card-".concat(i));
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__/* .EmptySpace */ .zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .BlogCtaButton */ .kj, {
                variant: "contained",
                onClick: function() {
                    window.open("https://1point.kr/blog/best-practices/");
                },
                children: "더 보러가기"
            })
        ]
    });
};
var BlogSection = function() {
    //
    var a = 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ContentsContainer */ .y3, {
        className: "column-center-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .SectionTitle */ .NZ, {
                children: "검증된 전문가의\n인사이트를 만나보세요"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .Empty */ .HY, {
                space: 40
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                order: "row-center-start",
                gap: 8,
                children: [
                    _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .InsightList.slice */ .aw.slice(0, 1).map(function(v, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .BigInsightCard */ .VD, {
                            onClick: function() {
                                window.open(v.url);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    className: "thumb",
                                    src: v.imgSrc
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .PaperA */ .iV, {
                                    variant: "transparent",
                                    px: 24,
                                    py: 24,
                                    order: "column-start-start",
                                    gap: 4,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                            order: "column-start-start",
                                            gap: 8,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "title",
                                                children: v.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                            order: "column-start-start",
                                            gap: 18,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "name",
                                                    children: [
                                                        "by ",
                                                        v.name
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "text",
                                                    children: v.text
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, "insight-card-".concat(i));
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                        order: "column-start-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "row-center-center",
                                style: {
                                    flexGrow: 1,
                                    flexShrink: 1,
                                    flexBasis: "0%",
                                    gap: 8
                                },
                                children: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .InsightList.slice */ .aw.slice(1, 3).map(function(v, i) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .InsightCard */ .L4, {
                                        onClick: function() {
                                            window.open(v.url);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                className: "thumb",
                                                src: v.imgSrc
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .PaperA */ .iV, {
                                                variant: "transparent",
                                                px: 16,
                                                py: 16,
                                                order: "column-start-start",
                                                gap: 4,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                                        order: "column-start-start",
                                                        gap: 8,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            className: "title",
                                                            children: v.title
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "name",
                                                        children: [
                                                            "by ",
                                                            v.name
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, "insight-card-".concat(i));
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "row-center-center",
                                style: {
                                    flexGrow: 1,
                                    flexShrink: 1,
                                    flexBasis: "0%",
                                    gap: 8
                                },
                                children: _base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .InsightList.slice */ .aw.slice(3, 5).map(function(v, i) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .InsightCard */ .L4, {
                                        onClick: function() {
                                            window.open(v.url);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_base_WebpImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                className: "thumb",
                                                src: v.imgSrc
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .PaperA */ .iV, {
                                                variant: "transparent",
                                                px: 16,
                                                py: 16,
                                                order: "column-start-start",
                                                gap: 4,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_ruix__WEBPACK_IMPORTED_MODULE_8__/* .GroupA */ .so, {
                                                        order: "column-start-start",
                                                        gap: 8,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            className: "title",
                                                            children: v.title
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "name",
                                                        children: [
                                                            "by ",
                                                            v.name
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, "insight-card-".concat(i));
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__/* .EmptySpace */ .zV, {
                space: 40
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .BlogCtaButton */ .kj, {
                variant: "contained",
                onClick: function() {
                    window.open("https://1point.kr/blog/insights/");
                },
                children: "더 보러가기"
            })
        ]
    });
};
var FAQContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div */ .Z.div(_templateObject1());
var FAQSection = function(props) {
    var list = props.list, noTitle = props.noTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .ContentsContainer */ .y3, {
        className: "column-center-center",
        children: [
            !noTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                sx: {
                    color: "#111827",
                    fontSize: {
                        xs: "28px",
                        sm: "32px",
                        md: "36px"
                    },
                    fontWeight: 800,
                    mb: 2,
                    textAlign: "center",
                    letterSpacing: "-0.03em",
                    lineHeight: 1.2
                },
                children: "자주 묻는 질문"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__/* .EmptySpace */ .zV, {
                space: 30
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FAQContainer, {
                children: list.map(function(faq, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .CustomAccordion */ .G1, {
                        defaultExpanded: i === 0,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_AccordionSummary__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                    htmlColor: "black"
                                }),
                                sx: {
                                    color: "var(--card-bg)"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .FAQAnswerTitle */ .yI, {
                                    children: [
                                        "Q. ",
                                        faq.title
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_AccordionDetails__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                sx: {
                                    color: "black",
                                    whiteSpace: "pre-wrap",
                                    background: "white",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "start",
                                    gap: "20px",
                                    paddingBottom: "20px",
                                    border: "none"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BaseContents__WEBPACK_IMPORTED_MODULE_16__/* .FAQAnswerDiv */ .Qf, {
                                    children: faq.answer
                                })
                            })
                        ]
                    }, "accordion-faq-".concat(i));
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_component_SignComponent__WEBPACK_IMPORTED_MODULE_5__/* .EmptySpace */ .zV, {
                space: 120
            })
        ]
    });
};


/***/ }),

/***/ 57386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Is": function() { return /* binding */ makePhoneNumber; },
/* harmony export */   "Ks": function() { return /* binding */ makePhoneNumberV2; },
/* harmony export */   "a$": function() { return /* binding */ validatePhone; },
/* harmony export */   "df": function() { return /* binding */ validatePhone2; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; }
/* harmony export */ });
function validateEmail(email) {
    return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}
function validatePhone(phone, isNotKorea) {
    if (isNotKorea) return true;
    return phone.length === 10 && phone.startsWith("10");
// const patternPhone = new RegExp("1[016789]-[^0][0-9]{2,3}-[0-9]{3,4}");
// if (patternPhone.test(phone)) {
// 	return true;
// }
// return false;
}
function validatePhone2(phone) {
    return phone.startsWith("010");
}
function makePhoneNumber(value) {
    var result = value;
    if (result.includes("-")) result = result.replace(/-/gi, "");
    if (result.length === 11 && result.startsWith("010")) return result.slice(1);
    return result;
}
function makePhoneNumberV2(value) {
    var result = value;
    if (result.includes("-")) result = result.replace(/-/gi, "");
    return result;
}


/***/ })

}]);